var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5469"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5469"] = parcelRequire;
}
parcelRequire.register("aOoPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7df1d498cbad1a7c$export$2e2bcd8739ae039);
/* global window */ 
var $1L2Rk = parcelRequire("1L2Rk");
var root;
if (typeof self !== "undefined") root = self;
else if (typeof window !== "undefined") root = window;
else if (typeof $parcel$global !== "undefined") root = $parcel$global;
else root = module;
var result = (0, $1L2Rk.default)(root);
var $7df1d498cbad1a7c$export$2e2bcd8739ae039 = result;

});
parcelRequire.register("1L2Rk", function(module, exports) {

$parcel$export(module.exports, "default", () => $147c6602c470abd5$export$2e2bcd8739ae039);
function $147c6602c470abd5$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol("observable");
            Symbol.observable = result;
        }
    } else result = "@@observable";
    return result;
}

});


var $9498ad806c1ca5b5$exports = {};
"use strict";
var $c150957174c75345$exports = {};
"use strict";
var $d2a481f66ffc782b$export$52c690bfbc972bc5;
var $d2a481f66ffc782b$export$b47a24b2eed06530;
var $d2a481f66ffc782b$export$4a9b37f09ecf68c3;
var $d2a481f66ffc782b$export$5f6331856bb188c4;
var $d2a481f66ffc782b$export$dc173136fc3bef09;
var $d2a481f66ffc782b$export$c1f420ffc4d09719;
// This variant only implements it with the extract-value flag set.
var $d2a481f66ffc782b$export$d9ed610363ddb782;
"use strict";
$d2a481f66ffc782b$export$52c690bfbc972bc5 = (string)=>{
    return string.replace(/^[ \t\n\r]+/u, "").replace(/[ \t\n\r]+$/u, "");
};
$d2a481f66ffc782b$export$b47a24b2eed06530 = (string)=>{
    return string.replace(/[ \t\n\r]+$/u, "");
};
$d2a481f66ffc782b$export$4a9b37f09ecf68c3 = (char)=>{
    return char === " " || char === "	" || char === "\n" || char === "\r";
};
$d2a481f66ffc782b$export$5f6331856bb188c4 = (string)=>{
    return /^[-!#$%&'*+.^_`|~A-Za-z0-9]*$/u.test(string);
};
$d2a481f66ffc782b$export$dc173136fc3bef09 = (string)=>{
    return /^[\t\u0020-\u007E\u0080-\u00FF]*$/u.test(string);
};
$d2a481f66ffc782b$export$c1f420ffc4d09719 = (string)=>{
    return string.replace(/[A-Z]/ug, (l)=>l.toLowerCase());
};
$d2a481f66ffc782b$export$d9ed610363ddb782 = (input, position)=>{
    let value = "";
    position++;
    while(true){
        while(position < input.length && input[position] !== '"' && input[position] !== "\\"){
            value += input[position];
            ++position;
        }
        if (position >= input.length) break;
        const quoteOrBackslash = input[position];
        ++position;
        if (quoteOrBackslash === "\\") {
            if (position >= input.length) {
                value += "\\";
                break;
            }
            value += input[position];
            ++position;
        } else break;
    }
    return [
        value,
        position
    ];
};


var $c150957174c75345$require$asciiLowercase = $d2a481f66ffc782b$export$c1f420ffc4d09719;
var $c150957174c75345$require$solelyContainsHTTPTokenCodePoints = $d2a481f66ffc782b$export$5f6331856bb188c4;
var $c150957174c75345$require$soleyContainsHTTPQuotedStringTokenCodePoints = $d2a481f66ffc782b$export$dc173136fc3bef09;
$c150957174c75345$exports = class MIMETypeParameters {
    constructor(map){
        this._map = map;
    }
    get size() {
        return this._map.size;
    }
    get(name) {
        name = $c150957174c75345$require$asciiLowercase(String(name));
        return this._map.get(name);
    }
    has(name) {
        name = $c150957174c75345$require$asciiLowercase(String(name));
        return this._map.has(name);
    }
    set(name, value) {
        name = $c150957174c75345$require$asciiLowercase(String(name));
        value = String(value);
        if (!$c150957174c75345$require$solelyContainsHTTPTokenCodePoints(name)) throw new Error(`Invalid MIME type parameter name "${name}": only HTTP token code points are valid.`);
        if (!$c150957174c75345$require$soleyContainsHTTPQuotedStringTokenCodePoints(value)) throw new Error(`Invalid MIME type parameter value "${value}": only HTTP quoted-string token code points are ` + `valid.`);
        return this._map.set(name, value);
    }
    clear() {
        this._map.clear();
    }
    delete(name) {
        name = $c150957174c75345$require$asciiLowercase(String(name));
        return this._map.delete(name);
    }
    forEach(callbackFn, thisArg) {
        this._map.forEach(callbackFn, thisArg);
    }
    keys() {
        return this._map.keys();
    }
    values() {
        return this._map.values();
    }
    entries() {
        return this._map.entries();
    }
    [Symbol.iterator]() {
        return this._map[Symbol.iterator]();
    }
};


var $caf4e07162bb6a61$exports = {};
"use strict";

var $caf4e07162bb6a61$require$removeLeadingAndTrailingHTTPWhitespace = $d2a481f66ffc782b$export$52c690bfbc972bc5;
var $caf4e07162bb6a61$require$removeTrailingHTTPWhitespace = $d2a481f66ffc782b$export$b47a24b2eed06530;
var $caf4e07162bb6a61$require$isHTTPWhitespaceChar = $d2a481f66ffc782b$export$4a9b37f09ecf68c3;
var $caf4e07162bb6a61$require$solelyContainsHTTPTokenCodePoints = $d2a481f66ffc782b$export$5f6331856bb188c4;
var $caf4e07162bb6a61$require$soleyContainsHTTPQuotedStringTokenCodePoints = $d2a481f66ffc782b$export$dc173136fc3bef09;
var $caf4e07162bb6a61$require$asciiLowercase = $d2a481f66ffc782b$export$c1f420ffc4d09719;
var $caf4e07162bb6a61$require$collectAnHTTPQuotedString = $d2a481f66ffc782b$export$d9ed610363ddb782;
$caf4e07162bb6a61$exports = (input)=>{
    input = $caf4e07162bb6a61$require$removeLeadingAndTrailingHTTPWhitespace(input);
    let position = 0;
    let type = "";
    while(position < input.length && input[position] !== "/"){
        type += input[position];
        ++position;
    }
    if (type.length === 0 || !$caf4e07162bb6a61$require$solelyContainsHTTPTokenCodePoints(type)) return null;
    if (position >= input.length) return null;
    // Skips past "/"
    ++position;
    let subtype = "";
    while(position < input.length && input[position] !== ";"){
        subtype += input[position];
        ++position;
    }
    subtype = $caf4e07162bb6a61$require$removeTrailingHTTPWhitespace(subtype);
    if (subtype.length === 0 || !$caf4e07162bb6a61$require$solelyContainsHTTPTokenCodePoints(subtype)) return null;
    const mimeType = {
        type: $caf4e07162bb6a61$require$asciiLowercase(type),
        subtype: $caf4e07162bb6a61$require$asciiLowercase(subtype),
        parameters: new Map()
    };
    while(position < input.length){
        // Skip past ";"
        ++position;
        while($caf4e07162bb6a61$require$isHTTPWhitespaceChar(input[position]))++position;
        let parameterName = "";
        while(position < input.length && input[position] !== ";" && input[position] !== "="){
            parameterName += input[position];
            ++position;
        }
        parameterName = $caf4e07162bb6a61$require$asciiLowercase(parameterName);
        if (position < input.length) {
            if (input[position] === ";") continue;
            // Skip past "="
            ++position;
        }
        let parameterValue = null;
        if (input[position] === '"') {
            [parameterValue, position] = $caf4e07162bb6a61$require$collectAnHTTPQuotedString(input, position);
            while(position < input.length && input[position] !== ";")++position;
        } else {
            parameterValue = "";
            while(position < input.length && input[position] !== ";"){
                parameterValue += input[position];
                ++position;
            }
            parameterValue = $caf4e07162bb6a61$require$removeTrailingHTTPWhitespace(parameterValue);
            if (parameterValue === "") continue;
        }
        if (parameterName.length > 0 && $caf4e07162bb6a61$require$solelyContainsHTTPTokenCodePoints(parameterName) && $caf4e07162bb6a61$require$soleyContainsHTTPQuotedStringTokenCodePoints(parameterValue) && !mimeType.parameters.has(parameterName)) mimeType.parameters.set(parameterName, parameterValue);
    }
    return mimeType;
};


var $4b9317056b981ba2$exports = {};
"use strict";

var $4b9317056b981ba2$require$solelyContainsHTTPTokenCodePoints = $d2a481f66ffc782b$export$5f6331856bb188c4;
$4b9317056b981ba2$exports = (mimeType)=>{
    let serialization = `${mimeType.type}/${mimeType.subtype}`;
    if (mimeType.parameters.size === 0) return serialization;
    for (let [name, value] of mimeType.parameters){
        serialization += ";";
        serialization += name;
        serialization += "=";
        if (!$4b9317056b981ba2$require$solelyContainsHTTPTokenCodePoints(value) || value.length === 0) {
            value = value.replace(/(["\\])/ug, "\\$1");
            value = `"${value}"`;
        }
        serialization += value;
    }
    return serialization;
};



var $9498ad806c1ca5b5$require$asciiLowercase = $d2a481f66ffc782b$export$c1f420ffc4d09719;
var $9498ad806c1ca5b5$require$solelyContainsHTTPTokenCodePoints = $d2a481f66ffc782b$export$5f6331856bb188c4;
$9498ad806c1ca5b5$exports = class MIMEType {
    constructor(string){
        string = String(string);
        const result = $caf4e07162bb6a61$exports(string);
        if (result === null) throw new Error(`Could not parse MIME type string "${string}"`);
        this._type = result.type;
        this._subtype = result.subtype;
        this._parameters = new $c150957174c75345$exports(result.parameters);
    }
    static parse(string) {
        try {
            return new this(string);
        } catch (e) {
            return null;
        }
    }
    get essence() {
        return `${this.type}/${this.subtype}`;
    }
    get type() {
        return this._type;
    }
    set type(value) {
        value = $9498ad806c1ca5b5$require$asciiLowercase(String(value));
        if (value.length === 0) throw new Error("Invalid type: must be a non-empty string");
        if (!$9498ad806c1ca5b5$require$solelyContainsHTTPTokenCodePoints(value)) throw new Error(`Invalid type ${value}: must contain only HTTP token code points`);
        this._type = value;
    }
    get subtype() {
        return this._subtype;
    }
    set subtype(value) {
        value = $9498ad806c1ca5b5$require$asciiLowercase(String(value));
        if (value.length === 0) throw new Error("Invalid subtype: must be a non-empty string");
        if (!$9498ad806c1ca5b5$require$solelyContainsHTTPTokenCodePoints(value)) throw new Error(`Invalid subtype ${value}: must contain only HTTP token code points`);
        this._subtype = value;
    }
    get parameters() {
        return this._parameters;
    }
    toString() {
        // The serialize function works on both "MIME type records" (i.e. the results of parse) and on this class, since
        // this class's interface is identical.
        return $4b9317056b981ba2$exports(this);
    }
    isJavaScript({ prohibitParameters: prohibitParameters = false } = {}) {
        switch(this._type){
            case "text":
                switch(this._subtype){
                    case "ecmascript":
                    case "javascript":
                    case "javascript1.0":
                    case "javascript1.1":
                    case "javascript1.2":
                    case "javascript1.3":
                    case "javascript1.4":
                    case "javascript1.5":
                    case "jscript":
                    case "livescript":
                    case "x-ecmascript":
                    case "x-javascript":
                        return !prohibitParameters || this._parameters.size === 0;
                    default:
                        return false;
                }
            case "application":
                switch(this._subtype){
                    case "ecmascript":
                    case "javascript":
                    case "x-ecmascript":
                    case "x-javascript":
                        return !prohibitParameters || this._parameters.size === 0;
                    default:
                        return false;
                }
            default:
                return false;
        }
    }
    isXML() {
        return this._subtype === "xml" && (this._type === "text" || this._type === "application") || this._subtype.endsWith("+xml");
    }
    isHTML() {
        return this._subtype === "html" && this._type === "text";
    }
};


function $f5f90e31cecb0539$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f5f90e31cecb0539$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f5f90e31cecb0539$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f5f90e31cecb0539$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f5f90e31cecb0539$var$_arrayLikeToArray(o, minLen);
}
function $f5f90e31cecb0539$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f5f90e31cecb0539$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f5f90e31cecb0539$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f5f90e31cecb0539$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f5f90e31cecb0539$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $f5f90e31cecb0539$var$hasSymbols = function() {
    return typeof Symbol === "function";
};
var $f5f90e31cecb0539$var$hasSymbol = function(name) {
    return $f5f90e31cecb0539$var$hasSymbols() && Boolean(Symbol[name]);
};
var $f5f90e31cecb0539$var$getSymbol = function(name) {
    return $f5f90e31cecb0539$var$hasSymbol(name) ? Symbol[name] : "@@" + name;
};
if ($f5f90e31cecb0539$var$hasSymbols() && !$f5f90e31cecb0539$var$hasSymbol("observable")) Symbol.observable = Symbol("observable");
var $f5f90e31cecb0539$var$SymbolIterator = $f5f90e31cecb0539$var$getSymbol("iterator");
var $f5f90e31cecb0539$var$SymbolObservable = $f5f90e31cecb0539$var$getSymbol("observable");
var $f5f90e31cecb0539$var$SymbolSpecies = $f5f90e31cecb0539$var$getSymbol("species"); // === Abstract Operations ===
function $f5f90e31cecb0539$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== "function") throw new TypeError(value + " is not a function");
    return value;
}
function $f5f90e31cecb0539$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$f5f90e31cecb0539$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $f5f90e31cecb0539$export$77cea355fa80b5f4;
}
function $f5f90e31cecb0539$var$isObservable(x) {
    return x instanceof $f5f90e31cecb0539$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $f5f90e31cecb0539$var$hostReportError(e) {
    if ($f5f90e31cecb0539$var$hostReportError.log) $f5f90e31cecb0539$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $f5f90e31cecb0539$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $f5f90e31cecb0539$var$hostReportError(e);
        }
    });
}
function $f5f90e31cecb0539$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === "function") cleanup();
        else {
            var unsubscribe = $f5f90e31cecb0539$var$getMethod(cleanup, "unsubscribe");
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $f5f90e31cecb0539$var$hostReportError(e);
    }
}
function $f5f90e31cecb0539$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = "closed";
}
function $f5f90e31cecb0539$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = "ready";
    for(var i = 0; i < queue.length; ++i){
        $f5f90e31cecb0539$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === "closed") break;
    }
}
function $f5f90e31cecb0539$var$notifySubscription(subscription, type, value) {
    subscription._state = "running";
    var observer = subscription._observer;
    try {
        var m = $f5f90e31cecb0539$var$getMethod(observer, type);
        switch(type){
            case "next":
                if (m) m.call(observer, value);
                break;
            case "error":
                $f5f90e31cecb0539$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case "complete":
                $f5f90e31cecb0539$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $f5f90e31cecb0539$var$hostReportError(e);
    }
    if (subscription._state === "closed") $f5f90e31cecb0539$var$cleanupSubscription(subscription);
    else if (subscription._state === "running") subscription._state = "ready";
}
function $f5f90e31cecb0539$var$onNotify(subscription, type, value) {
    if (subscription._state === "closed") return;
    if (subscription._state === "buffering") {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== "ready") {
        subscription._state = "buffering";
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $f5f90e31cecb0539$var$enqueue(function() {
            return $f5f90e31cecb0539$var$flushSubscription(subscription);
        });
        return;
    }
    $f5f90e31cecb0539$var$notifySubscription(subscription, type, value);
}
var $f5f90e31cecb0539$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = "initializing";
        var subscriptionObserver = new $f5f90e31cecb0539$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === "initializing") this._state = "ready";
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== "closed") {
            $f5f90e31cecb0539$var$closeSubscription(this);
            $f5f90e31cecb0539$var$cleanupSubscription(this);
        }
    };
    $f5f90e31cecb0539$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === "closed";
            }
        }
    ]);
    return Subscription;
}();
var $f5f90e31cecb0539$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $f5f90e31cecb0539$var$onNotify(this._subscription, "next", value);
    };
    _proto2.error = function error(value) {
        $f5f90e31cecb0539$var$onNotify(this._subscription, "error", value);
    };
    _proto2.complete = function complete() {
        $f5f90e31cecb0539$var$onNotify(this._subscription, "complete");
    };
    $f5f90e31cecb0539$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === "closed";
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $f5f90e31cecb0539$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== "object" || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $f5f90e31cecb0539$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== "function") {
                reject(new TypeError(fn + " is not a function"));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $f5f90e31cecb0539$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $f5f90e31cecb0539$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $f5f90e31cecb0539$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $f5f90e31cecb0539$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $f5f90e31cecb0539$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$f5f90e31cecb0539$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === "function" ? this : Observable;
        if (x == null) throw new TypeError(x + " is not an object");
        var method = $f5f90e31cecb0539$var$getMethod(x, $f5f90e31cecb0539$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + " is not an object");
            if ($f5f90e31cecb0539$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($f5f90e31cecb0539$var$hasSymbol("iterator")) {
            method = $f5f90e31cecb0539$var$getMethod(x, $f5f90e31cecb0539$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $f5f90e31cecb0539$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $f5f90e31cecb0539$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $f5f90e31cecb0539$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + " is not observable");
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === "function" ? this : Observable;
        return new C(function(observer) {
            $f5f90e31cecb0539$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $f5f90e31cecb0539$var$_createClass(Observable, null, [
        {
            key: $f5f90e31cecb0539$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($f5f90e31cecb0539$var$hasSymbols()) Object.defineProperty($f5f90e31cecb0539$export$77cea355fa80b5f4, Symbol("extensions"), {
    value: {
        symbol: $f5f90e31cecb0539$var$SymbolObservable,
        hostReportError: $f5f90e31cecb0539$var$hostReportError
    },
    configurable: true
});


var $7cc026d227a3af34$exports = {};
"use strict";
var $7cc026d227a3af34$var$has = Object.prototype.hasOwnProperty, $7cc026d227a3af34$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $7cc026d227a3af34$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $7cc026d227a3af34$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $7cc026d227a3af34$var$Events().__proto__) $7cc026d227a3af34$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $7cc026d227a3af34$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $7cc026d227a3af34$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $7cc026d227a3af34$var$EE(fn, context || emitter, once), evt = $7cc026d227a3af34$var$prefix ? $7cc026d227a3af34$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $7cc026d227a3af34$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $7cc026d227a3af34$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $7cc026d227a3af34$var$EventEmitter() {
    this._events = new $7cc026d227a3af34$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $7cc026d227a3af34$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($7cc026d227a3af34$var$has.call(events, name)) names.push($7cc026d227a3af34$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $7cc026d227a3af34$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $7cc026d227a3af34$var$prefix ? $7cc026d227a3af34$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $7cc026d227a3af34$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $7cc026d227a3af34$var$prefix ? $7cc026d227a3af34$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $7cc026d227a3af34$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $7cc026d227a3af34$var$prefix ? $7cc026d227a3af34$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7cc026d227a3af34$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $7cc026d227a3af34$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7cc026d227a3af34$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $7cc026d227a3af34$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7cc026d227a3af34$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $7cc026d227a3af34$var$prefix ? $7cc026d227a3af34$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $7cc026d227a3af34$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $7cc026d227a3af34$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $7cc026d227a3af34$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7cc026d227a3af34$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $7cc026d227a3af34$var$prefix ? $7cc026d227a3af34$var$prefix + event : event;
        if (this._events[evt]) $7cc026d227a3af34$var$clearEvent(this, evt);
    } else {
        this._events = new $7cc026d227a3af34$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$7cc026d227a3af34$var$EventEmitter.prototype.off = $7cc026d227a3af34$var$EventEmitter.prototype.removeListener;
$7cc026d227a3af34$var$EventEmitter.prototype.addListener = $7cc026d227a3af34$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$7cc026d227a3af34$var$EventEmitter.prefixed = $7cc026d227a3af34$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$7cc026d227a3af34$var$EventEmitter.EventEmitter = $7cc026d227a3af34$var$EventEmitter;
$7cc026d227a3af34$exports = $7cc026d227a3af34$var$EventEmitter;


var $beb4c57f69a29bbe$exports = {};
(function(global1, factory) {
    factory($beb4c57f69a29bbe$exports);
})($beb4c57f69a29bbe$exports, function(exports1) {
    "use strict";
    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }
    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
            return this;
        }, i;
        function verb(n) {
            if (g[n]) i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
        }
        function resume(n, v) {
            try {
                step(g[n](v));
            } catch (e) {
                settle(q[0][3], e);
            }
        }
        function step(r) {
            r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
        }
        function fulfill(value) {
            resume("next", value);
        }
        function reject(value) {
            resume("throw", value);
        }
        function settle(f, v) {
            if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
        }
    }
    /** @private */ function extendedTypeof(val) {
        if (val === null) return "null";
        if (Array.isArray(val)) return "array";
        return typeof val;
    }
    /** @private */ function isObject(val) {
        return extendedTypeof(val) === "object";
    }
    /** @private */ function areGraphQLErrors(obj) {
        return Array.isArray(obj) && // must be at least one error
        obj.length > 0 && // error has at least a message
        obj.every((ob)=>"message" in ob);
    }
    /**
     * Limits the WebSocket close event reason to not exceed a length of one frame.
     * Reference: https://datatracker.ietf.org/doc/html/rfc6455#section-5.2.
     *
     * @private
     */ function limitCloseReason(reason, whenTooLong) {
        return reason.length < 124 ? reason : whenTooLong;
    }
    /**
     *
     * common
     *
     */ /**
     * The WebSocket sub-protocol used for the [GraphQL over WebSocket Protocol](https://github.com/graphql/graphql-over-http/blob/main/rfcs/GraphQLOverWebSocket.md).
     *
     * @category Common
     */ const GRAPHQL_TRANSPORT_WS_PROTOCOL = "graphql-transport-ws";
    /**
     * The deprecated subprotocol used by [subscriptions-transport-ws](https://github.com/apollographql/subscriptions-transport-ws).
     *
     * @private
     */ const DEPRECATED_GRAPHQL_WS_PROTOCOL = "graphql-ws";
    /**
     * `graphql-ws` expected and standard close codes of the [GraphQL over WebSocket Protocol](https://github.com/graphql/graphql-over-http/blob/main/rfcs/GraphQLOverWebSocket.md).
     *
     * @category Common
     */ exports1.CloseCode = void 0;
    (function(CloseCode) {
        CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
        CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
        CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
        CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
        /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
        CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
        CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
        CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
        CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
        /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
        CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
    })(exports1.CloseCode || (exports1.CloseCode = {}));
    /**
     * Types of messages allowed to be sent by the client/server over the WS protocol.
     *
     * @category Common
     */ exports1.MessageType = void 0;
    (function(MessageType) {
        MessageType["ConnectionInit"] = "connection_init";
        MessageType["ConnectionAck"] = "connection_ack";
        MessageType["Ping"] = "ping";
        MessageType["Pong"] = "pong";
        MessageType["Subscribe"] = "subscribe";
        MessageType["Next"] = "next";
        MessageType["Error"] = "error";
        MessageType["Complete"] = "complete";
    })(exports1.MessageType || (exports1.MessageType = {}));
    /**
     * Validates the message against the GraphQL over WebSocket Protocol.
     *
     * Invalid messages will throw descriptive errors.
     *
     * @category Common
     */ function validateMessage(val) {
        if (!isObject(val)) throw new Error(`Message is expected to be an object, but got ${extendedTypeof(val)}`);
        if (!val.type) throw new Error(`Message is missing the 'type' property`);
        if (typeof val.type !== "string") throw new Error(`Message is expects the 'type' property to be a string, but got ${extendedTypeof(val.type)}`);
        switch(val.type){
            case exports1.MessageType.ConnectionInit:
            case exports1.MessageType.ConnectionAck:
            case exports1.MessageType.Ping:
            case exports1.MessageType.Pong:
                if (val.payload != null && !isObject(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
                break;
            case exports1.MessageType.Subscribe:
                if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
                if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
                if (!isObject(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${extendedTypeof(val.payload)}`);
                if (typeof val.payload.query !== "string") throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${extendedTypeof(val.payload.query)}`);
                if (val.payload.variables != null && !isObject(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${extendedTypeof(val.payload.variables)}`);
                if (val.payload.operationName != null && extendedTypeof(val.payload.operationName) !== "string") throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${extendedTypeof(val.payload.operationName)}`);
                if (val.payload.extensions != null && !isObject(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${extendedTypeof(val.payload.extensions)}`);
                break;
            case exports1.MessageType.Next:
                if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
                if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
                if (!isObject(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${extendedTypeof(val.payload)}`);
                break;
            case exports1.MessageType.Error:
                if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
                if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
                if (!areGraphQLErrors(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
                break;
            case exports1.MessageType.Complete:
                if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${extendedTypeof(val.id)}`);
                if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
                break;
            default:
                throw new Error(`Invalid message 'type' property "${val.type}"`);
        }
        return val;
    }
    /**
     * Checks if the provided value is a valid GraphQL over WebSocket message.
     *
     * @deprecated Use `validateMessage` instead.
     *
     * @category Common
     */ function isMessage(val) {
        try {
            validateMessage(val);
            return true;
        } catch (_a) {
            return false;
        }
    }
    /**
     * Parses the raw websocket message data to a valid message.
     *
     * @category Common
     */ function parseMessage(data, reviver) {
        return validateMessage(typeof data === "string" ? JSON.parse(data, reviver) : data);
    }
    /**
     * Stringifies a valid message ready to be sent through the socket.
     *
     * @category Common
     */ function stringifyMessage(msg, replacer) {
        validateMessage(msg);
        return JSON.stringify(msg, replacer);
    }
    /**
     *
     * client
     *
     */ /**
     * Creates a disposable GraphQL over WebSocket client.
     *
     * @category Client
     */ function createClient(options) {
        const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
            let retryDelay = 1000; // start with 1s delay
            for(let i = 0; i < retries; i++)retryDelay *= 2;
            await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
                Math.floor(Math.random() * 2700 + 300)));
        }, shouldRetry: shouldRetry = isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
         * Generates a v4 UUID to be used as the ID using `Math`
         * as the random number generator. Supply your own generator
         * in case you need more uniqueness.
         *
         * Reference: https://gist.github.com/jed/982883
         */ generateID = function generateUUID() {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
                const r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
                return v.toString(16);
            });
        }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
        let ws;
        if (webSocketImpl) {
            if (!isWebSocket(webSocketImpl)) throw new Error("Invalid WebSocket implementation provided");
            ws = webSocketImpl;
        } else if (typeof WebSocket !== "undefined") ws = WebSocket;
        else if (typeof $parcel$global !== "undefined") ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
        $parcel$global.MozWebSocket;
        else if (typeof window !== "undefined") ws = window.WebSocket || // @ts-expect-error: Support more browsers
        window.MozWebSocket;
        if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
        const WebSocketImpl = ws;
        // websocket status emitter, subscriptions are handled differently
        const emitter = (()=>{
            const message = (()=>{
                const listeners = {};
                return {
                    on (id, listener) {
                        listeners[id] = listener;
                        return ()=>{
                            delete listeners[id];
                        };
                    },
                    emit (message) {
                        var _a;
                        if ("id" in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                    }
                };
            })();
            const listeners = {
                connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                    on.connecting
                ] : [],
                opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                    on.opened
                ] : [],
                connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                    on.connected
                ] : [],
                ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                    on.ping
                ] : [],
                pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                    on.pong
                ] : [],
                message: (on === null || on === void 0 ? void 0 : on.message) ? [
                    message.emit,
                    on.message
                ] : [
                    message.emit
                ],
                closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                    on.closed
                ] : [],
                error: (on === null || on === void 0 ? void 0 : on.error) ? [
                    on.error
                ] : []
            };
            return {
                onMessage: message.on,
                on (event, listener) {
                    const l = listeners[event];
                    l.push(listener);
                    return ()=>{
                        l.splice(l.indexOf(listener), 1);
                    };
                },
                emit (event, ...args) {
                    // we copy the listeners so that unlistens dont "pull the rug under our feet"
                    for (const listener of [
                        ...listeners[event]
                    ])// @ts-expect-error: The args should fit
                    listener(...args);
                }
            };
        })();
        // invokes the callback either when an error or closed event is emitted,
        // first one that gets called prevails, other emissions are ignored
        function errorOrClosed(cb) {
            const listening = [
                // errors are fatal and more critical than close events, throw them first
                emitter.on("error", (err)=>{
                    listening.forEach((unlisten)=>unlisten());
                    cb(err);
                }),
                // closes can be graceful and not fatal, throw them second (if error didnt throw)
                emitter.on("closed", (event)=>{
                    listening.forEach((unlisten)=>unlisten());
                    cb(event);
                })
            ];
        }
        let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
        async function connect() {
            // clear the lazy close timeout immediatelly so that close gets debounced
            // see: https://github.com/enisdenjo/graphql-ws/issues/388
            clearTimeout(lazyCloseTimeout);
            const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                    if (retrying) {
                        await retryWait(retries);
                        // subscriptions might complete while waiting for retry
                        if (!locks) {
                            connecting = undefined;
                            return denied({
                                code: 1000,
                                reason: "All Subscriptions Gone"
                            });
                        }
                        retries++;
                    }
                    emitter.emit("connecting");
                    const socket = new WebSocketImpl(typeof url === "function" ? await url() : url, GRAPHQL_TRANSPORT_WS_PROTOCOL);
                    let connectionAckTimeout, queuedPing;
                    function enqueuePing() {
                        if (isFinite(keepAlive) && keepAlive > 0) {
                            clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                            queuedPing = setTimeout(()=>{
                                if (socket.readyState === WebSocketImpl.OPEN) {
                                    socket.send(stringifyMessage({
                                        type: exports1.MessageType.Ping
                                    }));
                                    emitter.emit("ping", false, undefined);
                                }
                            }, keepAlive);
                        }
                    }
                    errorOrClosed((errOrEvent)=>{
                        connecting = undefined;
                        clearTimeout(connectionAckTimeout);
                        clearTimeout(queuedPing);
                        denied(errOrEvent);
                        if (isLikeCloseEvent(errOrEvent) && errOrEvent.code === 4499) {
                            socket.close(4499, "Terminated"); // close event is artificial and emitted manually, see `Client.terminate()` below
                            socket.onerror = null;
                            socket.onclose = null;
                        }
                    });
                    socket.onerror = (err)=>emitter.emit("error", err);
                    socket.onclose = (event)=>emitter.emit("closed", event);
                    socket.onopen = async ()=>{
                        try {
                            emitter.emit("opened", socket);
                            const payload = typeof connectionParams === "function" ? await connectionParams() : connectionParams;
                            // connectionParams might take too long causing the server to kick off the client
                            // the necessary error/close event is already reported - simply stop execution
                            if (socket.readyState !== WebSocketImpl.OPEN) return;
                            socket.send(stringifyMessage(payload ? {
                                type: exports1.MessageType.ConnectionInit,
                                payload: payload
                            } : {
                                type: exports1.MessageType.ConnectionInit
                            }, replacer));
                            if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                                socket.close(exports1.CloseCode.ConnectionAcknowledgementTimeout, "Connection acknowledgement timeout");
                            }, connectionAckWaitTimeout);
                            enqueuePing(); // enqueue ping (noop if disabled)
                        } catch (err) {
                            emitter.emit("error", err);
                            socket.close(exports1.CloseCode.InternalClientError, limitCloseReason(err instanceof Error ? err.message : new Error(err).message, "Internal client error"));
                        }
                    };
                    let acknowledged = false;
                    socket.onmessage = ({ data: data })=>{
                        try {
                            const message = parseMessage(data, reviver);
                            emitter.emit("message", message);
                            if (message.type === "ping" || message.type === "pong") {
                                emitter.emit(message.type, true, message.payload); // received
                                if (message.type === "pong") enqueuePing(); // enqueue next ping (noop if disabled)
                                else if (!disablePong) {
                                    // respond with pong on ping
                                    socket.send(stringifyMessage(message.payload ? {
                                        type: exports1.MessageType.Pong,
                                        payload: message.payload
                                    } : {
                                        type: exports1.MessageType.Pong
                                    }));
                                    emitter.emit("pong", false, message.payload);
                                }
                                return; // ping and pongs can be received whenever
                            }
                            if (acknowledged) return; // already connected and acknowledged
                            if (message.type !== exports1.MessageType.ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                            clearTimeout(connectionAckTimeout);
                            acknowledged = true;
                            emitter.emit("connected", socket, message.payload); // connected = socket opened + acknowledged
                            retrying = false; // future lazy connects are not retries
                            retries = 0; // reset the retries on connect
                            connected([
                                socket,
                                new Promise((_, reject)=>errorOrClosed(reject))
                            ]);
                        } catch (err) {
                            socket.onmessage = null; // stop reading messages as soon as reading breaks once
                            emitter.emit("error", err);
                            socket.close(exports1.CloseCode.BadResponse, limitCloseReason(err instanceof Error ? err.message : new Error(err).message, "Bad response"));
                        }
                    };
                })()));
            // if the provided socket is in a closing state, wait for the throw on close
            if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
            let release = ()=>{
            // releases this connection
            };
            const released = new Promise((resolve)=>release = resolve);
            return [
                socket,
                release,
                Promise.race([
                    // wait for
                    released.then(()=>{
                        if (!locks) {
                            // and if no more locks are present, complete the connection
                            const complete = ()=>socket.close(1000, "Normal Closure");
                            if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                            // then complete if the socket is still open.
                            lazyCloseTimeout = setTimeout(()=>{
                                if (socket.readyState === WebSocketImpl.OPEN) complete();
                            }, lazyCloseTimeoutMs);
                            else // otherwise complete immediately
                            complete();
                        }
                    }),
                    // or
                    throwOnClose
                ])
            ];
        }
        /**
         * Checks the `connect` problem and evaluates if the client should retry.
         */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
            // some close codes are worth reporting immediately
            if (isLikeCloseEvent(errOrCloseEvent) && (isFatalInternalCloseCode(errOrCloseEvent.code) || [
                exports1.CloseCode.InternalServerError,
                exports1.CloseCode.InternalClientError,
                exports1.CloseCode.BadRequest,
                exports1.CloseCode.BadResponse,
                exports1.CloseCode.Unauthorized,
                // CloseCode.Forbidden, might grant access out after retry
                exports1.CloseCode.SubprotocolNotAcceptable,
                // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
                // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
                exports1.CloseCode.SubscriberAlreadyExists,
                exports1.CloseCode.TooManyInitialisationRequests
            ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
            // client was disposed, no retries should proceed regardless
            if (disposed) return false;
            // normal closure (possibly all subscriptions have completed)
            // if no locks were acquired in the meantime, shouldnt try again
            if (isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
            // retries are not allowed or we tried to many times, report error
            if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
            // throw non-retryable connection problems
            if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
            // @deprecated throw fatal connection problems immediately
            if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
            // looks good, start retrying
            return retrying = true;
        }
        // in non-lazy (hot?) mode always hold one connection lock to persist the socket
        if (!lazy) (async ()=>{
            locks++;
            for(;;)try {
                const [, , throwOnClose] = await connect();
                await throwOnClose; // will always throw because releaser is not used
            } catch (errOrCloseEvent) {
                try {
                    if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
                } catch (errOrCloseEvent) {
                    // report thrown error, no further retries
                    return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
                }
            }
        })();
        return {
            on: emitter.on,
            subscribe (payload, sink) {
                const id = generateID(payload);
                let done = false, errored = false, releaser = ()=>{
                    // for handling completions before connect
                    locks--;
                    done = true;
                };
                (async ()=>{
                    locks++;
                    for(;;)try {
                        const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                        // if done while waiting for connect, release the connection lock right away
                        if (done) return release();
                        const unlisten = emitter.onMessage(id, (message)=>{
                            switch(message.type){
                                case exports1.MessageType.Next:
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                                    sink.next(message.payload);
                                    return;
                                case exports1.MessageType.Error:
                                    errored = true, done = true;
                                    sink.error(message.payload);
                                    releaser();
                                    return;
                                case exports1.MessageType.Complete:
                                    done = true;
                                    releaser(); // release completes the sink
                                    return;
                            }
                        });
                        socket.send(stringifyMessage({
                            id: id,
                            type: exports1.MessageType.Subscribe,
                            payload: payload
                        }, replacer));
                        releaser = ()=>{
                            if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                            socket.send(stringifyMessage({
                                id: id,
                                type: exports1.MessageType.Complete
                            }, replacer));
                            locks--;
                            done = true;
                            release();
                        };
                        // either the releaser will be called, connection completed and
                        // the promise resolved or the socket closed and the promise rejected.
                        // whatever happens though, we want to stop listening for messages
                        await waitForReleaseOrThrowOnClose.finally(unlisten);
                        return; // completed, shouldnt try again
                    } catch (errOrCloseEvent) {
                        if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
                    }
                })().then(()=>{
                    // delivering either an error or a complete terminates the sequence
                    if (!errored) sink.complete();
                }) // resolves on release or normal closure
                .catch((err)=>{
                    sink.error(err);
                }); // rejects on close events and errors
                return ()=>{
                    // dispose only of active subscriptions
                    if (!done) releaser();
                };
            },
            iterate (request) {
                const pending = [];
                const deferred = {
                    done: false,
                    error: null,
                    resolve: ()=>{
                    // noop
                    }
                };
                const dispose = this.subscribe(request, {
                    next (val) {
                        pending.push(val);
                        deferred.resolve();
                    },
                    error (err) {
                        deferred.done = true;
                        deferred.error = err;
                        deferred.resolve();
                    },
                    complete () {
                        deferred.done = true;
                        deferred.resolve();
                    }
                });
                const iterator = function iterator() {
                    return __asyncGenerator(this, arguments, function* iterator_1() {
                        for(;;){
                            if (!pending.length) // only wait if there are no pending messages available
                            yield __await(new Promise((resolve)=>deferred.resolve = resolve));
                            // first flush
                            while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            yield yield __await(pending.shift());
                            // then error
                            if (deferred.error) throw deferred.error;
                            // or complete
                            if (deferred.done) return yield __await(void 0);
                        }
                    });
                }();
                iterator.throw = async (err)=>{
                    if (!deferred.done) {
                        deferred.done = true;
                        deferred.error = err;
                        deferred.resolve();
                    }
                    return {
                        done: true,
                        value: undefined
                    };
                };
                iterator.return = async ()=>{
                    dispose();
                    return {
                        done: true,
                        value: undefined
                    };
                };
                return iterator;
            },
            async dispose () {
                disposed = true;
                if (connecting) {
                    // if there is a connection, close it
                    const [socket] = await connecting;
                    socket.close(1000, "Normal Closure");
                }
            },
            terminate () {
                if (connecting) // only if there is a connection
                emitter.emit("closed", {
                    code: 4499,
                    reason: "Terminated",
                    wasClean: false
                });
            }
        };
    }
    function isLikeCloseEvent(val) {
        return isObject(val) && "code" in val && "reason" in val;
    }
    function isFatalInternalCloseCode(code) {
        if ([
            1000,
            1001,
            1006,
            1005,
            1012,
            1013,
            1013
        ].includes(code)) return false;
        // all other internal errors are fatal
        return code >= 1000 && code <= 1999;
    }
    function isWebSocket(val) {
        return typeof val === "function" && "constructor" in val && "CLOSED" in val && "CLOSING" in val && "CONNECTING" in val && "OPEN" in val;
    }
    exports1.DEPRECATED_GRAPHQL_WS_PROTOCOL = DEPRECATED_GRAPHQL_WS_PROTOCOL;
    exports1.GRAPHQL_TRANSPORT_WS_PROTOCOL = GRAPHQL_TRANSPORT_WS_PROTOCOL;
    exports1.createClient = createClient;
    exports1.isMessage = isMessage;
    exports1.parseMessage = parseMessage;
    exports1.stringifyMessage = stringifyMessage;
    exports1.validateMessage = validateMessage;
});


var $af112994a64f4658$exports = {};
"use strict";
var $af112994a64f4658$var$__assign = $af112994a64f4658$exports && $af112994a64f4658$exports.__assign || function() {
    $af112994a64f4658$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $af112994a64f4658$var$__assign.apply(this, arguments);
};
var $af112994a64f4658$var$__awaiter = $af112994a64f4658$exports && $af112994a64f4658$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $af112994a64f4658$var$__generator = $af112994a64f4658$exports && $af112994a64f4658$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $af112994a64f4658$var$__spreadArray = $af112994a64f4658$exports && $af112994a64f4658$exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty($af112994a64f4658$exports, "__esModule", {
    value: true
});
$af112994a64f4658$exports.SubscriptionClient = void 0;
var $af112994a64f4658$var$_global = typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : {};
var $af112994a64f4658$var$NativeWebSocket = $af112994a64f4658$var$_global.WebSocket || $af112994a64f4658$var$_global.MozWebSocket;
var $559c898bbe5275bb$exports = {};
/**
 * Expose `Backoff`.
 */ $559c898bbe5275bb$exports = $559c898bbe5275bb$var$Backoff;
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $559c898bbe5275bb$var$Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $559c898bbe5275bb$var$Backoff.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $559c898bbe5275bb$var$Backoff.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $559c898bbe5275bb$var$Backoff.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $559c898bbe5275bb$var$Backoff.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $559c898bbe5275bb$var$Backoff.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



var $13eaac7b439f9222$exports = {};
"use strict";
Object.defineProperty($13eaac7b439f9222$exports, "__esModule", {
    value: true
});
function $13eaac7b439f9222$var$isString(value) {
    return typeof value === "string";
}
$13eaac7b439f9222$exports.default = $13eaac7b439f9222$var$isString;


var $e2dc805d47b2fe5c$exports = {};
"use strict";
Object.defineProperty($e2dc805d47b2fe5c$exports, "__esModule", {
    value: true
});
function $e2dc805d47b2fe5c$var$isObject(value) {
    return value !== null && typeof value === "object";
}
$e2dc805d47b2fe5c$exports.default = $e2dc805d47b2fe5c$var$isObject;


var $ca64cd2ab238d4ac$exports = {};
"use strict";
Object.defineProperty($ca64cd2ab238d4ac$exports, "__esModule", {
    value: true
});
$ca64cd2ab238d4ac$exports.print = $ca64cd2ab238d4ac$var$print;
var $f68343f6d13ac86e$exports = {};
"use strict";
Object.defineProperty($f68343f6d13ac86e$exports, "__esModule", {
    value: true
});
$f68343f6d13ac86e$exports.dedentBlockStringLines = $f68343f6d13ac86e$var$dedentBlockStringLines;
$f68343f6d13ac86e$exports.isPrintableAsBlockString = $f68343f6d13ac86e$var$isPrintableAsBlockString;
$f68343f6d13ac86e$exports.printBlockString = $f68343f6d13ac86e$var$printBlockString;
var $8a576fadf970b90e$exports = {};
"use strict";
Object.defineProperty($8a576fadf970b90e$exports, "__esModule", {
    value: true
});
$8a576fadf970b90e$exports.isDigit = $8a576fadf970b90e$var$isDigit;
$8a576fadf970b90e$exports.isLetter = $8a576fadf970b90e$var$isLetter;
$8a576fadf970b90e$exports.isNameContinue = $8a576fadf970b90e$var$isNameContinue;
$8a576fadf970b90e$exports.isNameStart = $8a576fadf970b90e$var$isNameStart;
$8a576fadf970b90e$exports.isWhiteSpace = $8a576fadf970b90e$var$isWhiteSpace;
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $8a576fadf970b90e$var$isWhiteSpace(code) {
    return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */ function $8a576fadf970b90e$var$isDigit(code) {
    return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */ function $8a576fadf970b90e$var$isLetter(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */ function $8a576fadf970b90e$var$isNameStart(code) {
    return $8a576fadf970b90e$var$isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */ function $8a576fadf970b90e$var$isNameContinue(code) {
    return $8a576fadf970b90e$var$isLetter(code) || $8a576fadf970b90e$var$isDigit(code) || code === 0x005f;
}


/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $f68343f6d13ac86e$var$dedentBlockStringLines(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $f68343f6d13ac86e$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $f68343f6d13ac86e$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $8a576fadf970b90e$exports.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
/**
 * @internal
 */ function $f68343f6d13ac86e$var$isPrintableAsBlockString(value) {
    if (value === "") return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */ function $f68343f6d13ac86e$var$printBlockString(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $8a576fadf970b90e$exports.isWhiteSpace)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith("\\");
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ""; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $8a576fadf970b90e$exports.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}


var $da0abd615b420bb2$exports = {};
"use strict";
Object.defineProperty($da0abd615b420bb2$exports, "__esModule", {
    value: true
});
$da0abd615b420bb2$exports.printString = $da0abd615b420bb2$var$printString;
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $da0abd615b420bb2$var$printString(str) {
    return `"${str.replace($da0abd615b420bb2$var$escapedRegExp, $da0abd615b420bb2$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $da0abd615b420bb2$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $da0abd615b420bb2$var$escapedReplacer(str) {
    return $da0abd615b420bb2$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $da0abd615b420bb2$var$escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];


var $d231047210b83ec3$exports = {};
"use strict";
Object.defineProperty($d231047210b83ec3$exports, "__esModule", {
    value: true
});
$d231047210b83ec3$exports.BREAK = void 0;
$d231047210b83ec3$exports.getEnterLeaveForKind = $d231047210b83ec3$var$getEnterLeaveForKind;
$d231047210b83ec3$exports.getVisitFn = $d231047210b83ec3$var$getVisitFn;
$d231047210b83ec3$exports.visit = $d231047210b83ec3$var$visit;
$d231047210b83ec3$exports.visitInParallel = $d231047210b83ec3$var$visitInParallel;
var $79d530c1166d414f$exports = {};
"use strict";
Object.defineProperty($79d530c1166d414f$exports, "__esModule", {
    value: true
});
$79d530c1166d414f$exports.devAssert = $79d530c1166d414f$var$devAssert;
function $79d530c1166d414f$var$devAssert(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


var $6cf323762dbba2ce$exports = {};
"use strict";
Object.defineProperty($6cf323762dbba2ce$exports, "__esModule", {
    value: true
});
$6cf323762dbba2ce$exports.inspect = $6cf323762dbba2ce$var$inspect;
const $6cf323762dbba2ce$var$MAX_ARRAY_LENGTH = 10;
const $6cf323762dbba2ce$var$MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */ function $6cf323762dbba2ce$var$inspect(value) {
    return $6cf323762dbba2ce$var$formatValue(value, []);
}
function $6cf323762dbba2ce$var$formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return $6cf323762dbba2ce$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $6cf323762dbba2ce$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($6cf323762dbba2ce$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $6cf323762dbba2ce$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $6cf323762dbba2ce$var$formatArray(value, seenValues);
    return $6cf323762dbba2ce$var$formatObject(value, seenValues);
}
function $6cf323762dbba2ce$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $6cf323762dbba2ce$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $6cf323762dbba2ce$var$MAX_RECURSIVE_DEPTH) return "[" + $6cf323762dbba2ce$var$getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + $6cf323762dbba2ce$var$formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function $6cf323762dbba2ce$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $6cf323762dbba2ce$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min($6cf323762dbba2ce$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($6cf323762dbba2ce$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function $6cf323762dbba2ce$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}


var $933ef15aedb84581$exports = {};
"use strict";
Object.defineProperty($933ef15aedb84581$exports, "__esModule", {
    value: true
});
$933ef15aedb84581$exports.Token = $933ef15aedb84581$exports.QueryDocumentKeys = $933ef15aedb84581$exports.OperationTypeNode = $933ef15aedb84581$exports.Location = void 0;
$933ef15aedb84581$exports.isNode = $933ef15aedb84581$var$isNode;
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $933ef15aedb84581$var$Location {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */ $933ef15aedb84581$exports.Location = $933ef15aedb84581$var$Location;
class $933ef15aedb84581$var$Token {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
/**
 * The list of all possible AST node types.
 */ $933ef15aedb84581$exports.Token = $933ef15aedb84581$var$Token;
/**
 * @internal
 */ const $933ef15aedb84581$var$QueryDocumentKeys = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
$933ef15aedb84581$exports.QueryDocumentKeys = $933ef15aedb84581$var$QueryDocumentKeys;
const $933ef15aedb84581$var$kindValues = new Set(Object.keys($933ef15aedb84581$var$QueryDocumentKeys));
/**
 * @internal
 */ function $933ef15aedb84581$var$isNode(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $933ef15aedb84581$var$kindValues.has(maybeKind);
}
/** Name */ var $933ef15aedb84581$var$OperationTypeNode;
$933ef15aedb84581$exports.OperationTypeNode = $933ef15aedb84581$var$OperationTypeNode;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($933ef15aedb84581$var$OperationTypeNode || ($933ef15aedb84581$exports.OperationTypeNode = $933ef15aedb84581$var$OperationTypeNode = {}));


var $a8b75bb5664d3479$exports = {};
"use strict";
Object.defineProperty($a8b75bb5664d3479$exports, "__esModule", {
    value: true
});
$a8b75bb5664d3479$exports.Kind = void 0;
/**
 * The set of allowed kind values for AST nodes.
 */ var $a8b75bb5664d3479$var$Kind;
$a8b75bb5664d3479$exports.Kind = $a8b75bb5664d3479$var$Kind;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($a8b75bb5664d3479$var$Kind || ($a8b75bb5664d3479$exports.Kind = $a8b75bb5664d3479$var$Kind = {})); /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 


const $d231047210b83ec3$var$BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */ $d231047210b83ec3$exports.BREAK = $d231047210b83ec3$var$BREAK;
function $d231047210b83ec3$var$visit(root, visitor, visitorKeys = $933ef15aedb84581$exports.QueryDocumentKeys) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values($a8b75bb5664d3479$exports.Kind))enterLeaveMap.set(kind, $d231047210b83ec3$var$getEnterLeaveForKind(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $933ef15aedb84581$exports.isNode)(node) || (0, $79d530c1166d414f$exports.devAssert)(false, `Invalid AST Node: ${(0, $6cf323762dbba2ce$exports.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $d231047210b83ec3$var$BREAK) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $933ef15aedb84581$exports.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function $d231047210b83ec3$var$visitInParallel(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values($a8b75bb5664d3479$exports.Kind)){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $d231047210b83ec3$var$getEnterLeaveForKind(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $d231047210b83ec3$var$BREAK) skipping[i] = $d231047210b83ec3$var$BREAK;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $d231047210b83ec3$var$BREAK) skipping[i] = $d231047210b83ec3$var$BREAK;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */ function $d231047210b83ec3$var$getEnterLeaveForKind(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */ /* c8 ignore next 8 */ function $d231047210b83ec3$var$getVisitFn(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $d231047210b83ec3$var$getEnterLeaveForKind(visitor, kind);
    return isLeaving ? leave : enter;
}


/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ function $ca64cd2ab238d4ac$var$print(ast) {
    return (0, $d231047210b83ec3$exports.visit)(ast, $ca64cd2ab238d4ac$var$printDocASTReducer);
}
const $ca64cd2ab238d4ac$var$MAX_LINE_LENGTH = 80;
const $ca64cd2ab238d4ac$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>"$" + node.name
    },
    // Document
    Document: {
        leave: (node)=>$ca64cd2ab238d4ac$var$join(node.definitions, "\n\n")
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $ca64cd2ab238d4ac$var$wrap("(", $ca64cd2ab238d4ac$var$join(node.variableDefinitions, ", "), ")");
            const prefix = $ca64cd2ab238d4ac$var$join([
                node.operation,
                $ca64cd2ab238d4ac$var$join([
                    node.name,
                    varDefs
                ]),
                $ca64cd2ab238d4ac$var$join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ": " + type + $ca64cd2ab238d4ac$var$wrap(" = ", defaultValue) + $ca64cd2ab238d4ac$var$wrap(" ", $ca64cd2ab238d4ac$var$join(directives, " "))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$ca64cd2ab238d4ac$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $ca64cd2ab238d4ac$var$wrap("", alias, ": ") + name;
            let argsLine = prefix + $ca64cd2ab238d4ac$var$wrap("(", $ca64cd2ab238d4ac$var$join(args, ", "), ")");
            if (argsLine.length > $ca64cd2ab238d4ac$var$MAX_LINE_LENGTH) argsLine = prefix + $ca64cd2ab238d4ac$var$wrap("(\n", $ca64cd2ab238d4ac$var$indent($ca64cd2ab238d4ac$var$join(args, "\n")), "\n)");
            return $ca64cd2ab238d4ac$var$join([
                argsLine,
                $ca64cd2ab238d4ac$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>"..." + name + $ca64cd2ab238d4ac$var$wrap(" ", $ca64cd2ab238d4ac$var$join(directives, " "))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$ca64cd2ab238d4ac$var$join([
                "...",
                $ca64cd2ab238d4ac$var$wrap("on ", typeCondition),
                $ca64cd2ab238d4ac$var$join(directives, " "),
                selectionSet
            ], " ")
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$ca64cd2ab238d4ac$var$wrap("(", $ca64cd2ab238d4ac$var$join(variableDefinitions, ", "), ")")} ` + `on ${typeCondition} ${$ca64cd2ab238d4ac$var$wrap("", $ca64cd2ab238d4ac$var$join(directives, " "), " ")}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $f68343f6d13ac86e$exports.printBlockString)(value) : (0, $da0abd615b420bb2$exports.printString)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? "true" : "false"
    },
    NullValue: {
        leave: ()=>"null"
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>"[" + $ca64cd2ab238d4ac$var$join(values, ", ") + "]"
    },
    ObjectValue: {
        leave: ({ fields: fields })=>"{" + $ca64cd2ab238d4ac$var$join(fields, ", ") + "}"
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>"@" + name + $ca64cd2ab238d4ac$var$wrap("(", $ca64cd2ab238d4ac$var$join(args, ", "), ")")
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>"[" + type + "]"
    },
    NonNullType: {
        leave: ({ type: type })=>type + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$ca64cd2ab238d4ac$var$wrap("", description, "\n") + $ca64cd2ab238d4ac$var$join([
                "schema",
                $ca64cd2ab238d4ac$var$join(directives, " "),
                $ca64cd2ab238d4ac$var$block(operationTypes)
            ], " ")
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ": " + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$ca64cd2ab238d4ac$var$wrap("", description, "\n") + $ca64cd2ab238d4ac$var$join([
                "scalar",
                name,
                $ca64cd2ab238d4ac$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$ca64cd2ab238d4ac$var$wrap("", description, "\n") + $ca64cd2ab238d4ac$var$join([
                "type",
                name,
                $ca64cd2ab238d4ac$var$wrap("implements ", $ca64cd2ab238d4ac$var$join(interfaces, " & ")),
                $ca64cd2ab238d4ac$var$join(directives, " "),
                $ca64cd2ab238d4ac$var$block(fields)
            ], " ")
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$ca64cd2ab238d4ac$var$wrap("", description, "\n") + name + ($ca64cd2ab238d4ac$var$hasMultilineItems(args) ? $ca64cd2ab238d4ac$var$wrap("(\n", $ca64cd2ab238d4ac$var$indent($ca64cd2ab238d4ac$var$join(args, "\n")), "\n)") : $ca64cd2ab238d4ac$var$wrap("(", $ca64cd2ab238d4ac$var$join(args, ", "), ")")) + ": " + type + $ca64cd2ab238d4ac$var$wrap(" ", $ca64cd2ab238d4ac$var$join(directives, " "))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$ca64cd2ab238d4ac$var$wrap("", description, "\n") + $ca64cd2ab238d4ac$var$join([
                name + ": " + type,
                $ca64cd2ab238d4ac$var$wrap("= ", defaultValue),
                $ca64cd2ab238d4ac$var$join(directives, " ")
            ], " ")
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$ca64cd2ab238d4ac$var$wrap("", description, "\n") + $ca64cd2ab238d4ac$var$join([
                "interface",
                name,
                $ca64cd2ab238d4ac$var$wrap("implements ", $ca64cd2ab238d4ac$var$join(interfaces, " & ")),
                $ca64cd2ab238d4ac$var$join(directives, " "),
                $ca64cd2ab238d4ac$var$block(fields)
            ], " ")
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$ca64cd2ab238d4ac$var$wrap("", description, "\n") + $ca64cd2ab238d4ac$var$join([
                "union",
                name,
                $ca64cd2ab238d4ac$var$join(directives, " "),
                $ca64cd2ab238d4ac$var$wrap("= ", $ca64cd2ab238d4ac$var$join(types, " | "))
            ], " ")
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$ca64cd2ab238d4ac$var$wrap("", description, "\n") + $ca64cd2ab238d4ac$var$join([
                "enum",
                name,
                $ca64cd2ab238d4ac$var$join(directives, " "),
                $ca64cd2ab238d4ac$var$block(values)
            ], " ")
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$ca64cd2ab238d4ac$var$wrap("", description, "\n") + $ca64cd2ab238d4ac$var$join([
                name,
                $ca64cd2ab238d4ac$var$join(directives, " ")
            ], " ")
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$ca64cd2ab238d4ac$var$wrap("", description, "\n") + $ca64cd2ab238d4ac$var$join([
                "input",
                name,
                $ca64cd2ab238d4ac$var$join(directives, " "),
                $ca64cd2ab238d4ac$var$block(fields)
            ], " ")
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$ca64cd2ab238d4ac$var$wrap("", description, "\n") + "directive @" + name + ($ca64cd2ab238d4ac$var$hasMultilineItems(args) ? $ca64cd2ab238d4ac$var$wrap("(\n", $ca64cd2ab238d4ac$var$indent($ca64cd2ab238d4ac$var$join(args, "\n")), "\n)") : $ca64cd2ab238d4ac$var$wrap("(", $ca64cd2ab238d4ac$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $ca64cd2ab238d4ac$var$join(locations, " | ")
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$ca64cd2ab238d4ac$var$join([
                "extend schema",
                $ca64cd2ab238d4ac$var$join(directives, " "),
                $ca64cd2ab238d4ac$var$block(operationTypes)
            ], " ")
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$ca64cd2ab238d4ac$var$join([
                "extend scalar",
                name,
                $ca64cd2ab238d4ac$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$ca64cd2ab238d4ac$var$join([
                "extend type",
                name,
                $ca64cd2ab238d4ac$var$wrap("implements ", $ca64cd2ab238d4ac$var$join(interfaces, " & ")),
                $ca64cd2ab238d4ac$var$join(directives, " "),
                $ca64cd2ab238d4ac$var$block(fields)
            ], " ")
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$ca64cd2ab238d4ac$var$join([
                "extend interface",
                name,
                $ca64cd2ab238d4ac$var$wrap("implements ", $ca64cd2ab238d4ac$var$join(interfaces, " & ")),
                $ca64cd2ab238d4ac$var$join(directives, " "),
                $ca64cd2ab238d4ac$var$block(fields)
            ], " ")
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$ca64cd2ab238d4ac$var$join([
                "extend union",
                name,
                $ca64cd2ab238d4ac$var$join(directives, " "),
                $ca64cd2ab238d4ac$var$wrap("= ", $ca64cd2ab238d4ac$var$join(types, " | "))
            ], " ")
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$ca64cd2ab238d4ac$var$join([
                "extend enum",
                name,
                $ca64cd2ab238d4ac$var$join(directives, " "),
                $ca64cd2ab238d4ac$var$block(values)
            ], " ")
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$ca64cd2ab238d4ac$var$join([
                "extend input",
                name,
                $ca64cd2ab238d4ac$var$join(directives, " "),
                $ca64cd2ab238d4ac$var$block(fields)
            ], " ")
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $ca64cd2ab238d4ac$var$join(maybeArray, separator = "") {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $ca64cd2ab238d4ac$var$block(array) {
    return $ca64cd2ab238d4ac$var$wrap("{\n", $ca64cd2ab238d4ac$var$indent($ca64cd2ab238d4ac$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $ca64cd2ab238d4ac$var$wrap(start, maybeString, end = "") {
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $ca64cd2ab238d4ac$var$indent(str) {
    return $ca64cd2ab238d4ac$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $ca64cd2ab238d4ac$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}


var $9ac26eed8d9fa31d$exports = {};
"use strict";
Object.defineProperty($9ac26eed8d9fa31d$exports, "__esModule", {
    value: true
});
$9ac26eed8d9fa31d$exports.getOperationAST = $9ac26eed8d9fa31d$var$getOperationAST;

/**
 * Returns an operation AST given a document AST and optionally an operation
 * name. If a name is not provided, an operation is only returned if only one is
 * provided in the document.
 */ function $9ac26eed8d9fa31d$var$getOperationAST(documentAST, operationName) {
    let operation = null;
    for (const definition of documentAST.definitions)if (definition.kind === $a8b75bb5664d3479$exports.Kind.OPERATION_DEFINITION) {
        var _definition$name;
        if (operationName == null) {
            // If no operation name was provided, only return an Operation if there
            // is one defined in the document. Upon encountering the second, return
            // null.
            if (operation) return null;
            operation = definition;
        } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) return definition;
    }
    return operation;
}



var $aOoPc = parcelRequire("aOoPc");
var $23fc3cc3b079abd9$exports = {};
"use strict";
Object.defineProperty($23fc3cc3b079abd9$exports, "__esModule", {
    value: true
});
$23fc3cc3b079abd9$exports.GRAPHQL_SUBSCRIPTIONS = $23fc3cc3b079abd9$exports.GRAPHQL_WS = void 0;
var $23fc3cc3b079abd9$var$GRAPHQL_WS = "graphql-ws";
$23fc3cc3b079abd9$exports.GRAPHQL_WS = $23fc3cc3b079abd9$var$GRAPHQL_WS;
var $23fc3cc3b079abd9$var$GRAPHQL_SUBSCRIPTIONS = "graphql-subscriptions";
$23fc3cc3b079abd9$exports.GRAPHQL_SUBSCRIPTIONS = $23fc3cc3b079abd9$var$GRAPHQL_SUBSCRIPTIONS;


var $4daf625388fbe7c6$exports = {};
"use strict";
Object.defineProperty($4daf625388fbe7c6$exports, "__esModule", {
    value: true
});
$4daf625388fbe7c6$exports.WS_TIMEOUT = $4daf625388fbe7c6$exports.MIN_WS_TIMEOUT = void 0;
var $4daf625388fbe7c6$var$MIN_WS_TIMEOUT = 1000;
$4daf625388fbe7c6$exports.MIN_WS_TIMEOUT = $4daf625388fbe7c6$var$MIN_WS_TIMEOUT;
var $4daf625388fbe7c6$var$WS_TIMEOUT = 30000;
$4daf625388fbe7c6$exports.WS_TIMEOUT = $4daf625388fbe7c6$var$WS_TIMEOUT;


var $04a39a3dc631764d$exports = {};
"use strict";
Object.defineProperty($04a39a3dc631764d$exports, "__esModule", {
    value: true
});
var $04a39a3dc631764d$var$MessageTypes = function() {
    function MessageTypes() {
        throw new Error("Static Class");
    }
    MessageTypes.GQL_CONNECTION_INIT = "connection_init";
    MessageTypes.GQL_CONNECTION_ACK = "connection_ack";
    MessageTypes.GQL_CONNECTION_ERROR = "connection_error";
    MessageTypes.GQL_CONNECTION_KEEP_ALIVE = "ka";
    MessageTypes.GQL_CONNECTION_TERMINATE = "connection_terminate";
    MessageTypes.GQL_START = "start";
    MessageTypes.GQL_DATA = "data";
    MessageTypes.GQL_ERROR = "error";
    MessageTypes.GQL_COMPLETE = "complete";
    MessageTypes.GQL_STOP = "stop";
    MessageTypes.SUBSCRIPTION_START = "subscription_start";
    MessageTypes.SUBSCRIPTION_DATA = "subscription_data";
    MessageTypes.SUBSCRIPTION_SUCCESS = "subscription_success";
    MessageTypes.SUBSCRIPTION_FAIL = "subscription_fail";
    MessageTypes.SUBSCRIPTION_END = "subscription_end";
    MessageTypes.INIT = "init";
    MessageTypes.INIT_SUCCESS = "init_success";
    MessageTypes.INIT_FAIL = "init_fail";
    MessageTypes.KEEP_ALIVE = "keepalive";
    return MessageTypes;
}();
$04a39a3dc631764d$exports.default = $04a39a3dc631764d$var$MessageTypes;


var $af112994a64f4658$var$SubscriptionClient = function() {
    function SubscriptionClient(url, options, webSocketImpl, webSocketProtocols) {
        var _a = options || {}, _b = _a.connectionCallback, connectionCallback = _b === void 0 ? undefined : _b, _c = _a.connectionParams, connectionParams = _c === void 0 ? {} : _c, _d = _a.minTimeout, minTimeout = _d === void 0 ? $4daf625388fbe7c6$exports.MIN_WS_TIMEOUT : _d, _e = _a.timeout, timeout = _e === void 0 ? $4daf625388fbe7c6$exports.WS_TIMEOUT : _e, _f = _a.reconnect, reconnect = _f === void 0 ? false : _f, _g = _a.reconnectionAttempts, reconnectionAttempts = _g === void 0 ? Infinity : _g, _h = _a.lazy, lazy = _h === void 0 ? false : _h, _j = _a.inactivityTimeout, inactivityTimeout = _j === void 0 ? 0 : _j, _k = _a.wsOptionArguments, wsOptionArguments = _k === void 0 ? [] : _k;
        this.wsImpl = webSocketImpl || $af112994a64f4658$var$NativeWebSocket;
        if (!this.wsImpl) throw new Error("Unable to find native implementation, or alternative implementation for WebSocket!");
        this.wsProtocols = webSocketProtocols || $23fc3cc3b079abd9$exports.GRAPHQL_WS;
        this.connectionCallback = connectionCallback;
        this.url = url;
        this.operations = {};
        this.nextOperationId = 0;
        this.minWsTimeout = minTimeout;
        this.wsTimeout = timeout;
        this.unsentMessagesQueue = [];
        this.reconnect = reconnect;
        this.reconnecting = false;
        this.reconnectionAttempts = reconnectionAttempts;
        this.lazy = !!lazy;
        this.inactivityTimeout = inactivityTimeout;
        this.closedByUser = false;
        this.backoff = new $559c898bbe5275bb$exports({
            jitter: 0.5
        });
        this.eventEmitter = new $7cc026d227a3af34$exports.EventEmitter();
        this.middlewares = [];
        this.client = null;
        this.maxConnectTimeGenerator = this.createMaxConnectTimeGenerator();
        this.connectionParams = this.getConnectionParams(connectionParams);
        this.wsOptionArguments = wsOptionArguments;
        if (!this.lazy) this.connect();
    }
    Object.defineProperty(SubscriptionClient.prototype, "status", {
        get: function() {
            if (this.client === null) return this.wsImpl.CLOSED;
            return this.client.readyState;
        },
        enumerable: false,
        configurable: true
    });
    SubscriptionClient.prototype.close = function(isForced, closedByUser) {
        if (isForced === void 0) isForced = true;
        if (closedByUser === void 0) closedByUser = true;
        this.clearInactivityTimeout();
        if (this.client !== null) {
            this.closedByUser = closedByUser;
            if (isForced) {
                this.clearCheckConnectionInterval();
                this.clearMaxConnectTimeout();
                this.clearTryReconnectTimeout();
                this.unsubscribeAll();
                this.sendMessage(undefined, $04a39a3dc631764d$exports.default.GQL_CONNECTION_TERMINATE, null);
            }
            this.client.close();
            this.client.onopen = null;
            this.client.onclose = null;
            this.client.onerror = null;
            this.client.onmessage = null;
            this.client = null;
            this.eventEmitter.emit("disconnected");
            if (!isForced) this.tryReconnect();
        }
    };
    SubscriptionClient.prototype.request = function(request) {
        var _a;
        var getObserver = this.getObserver.bind(this);
        var executeOperation = this.executeOperation.bind(this);
        var unsubscribe = this.unsubscribe.bind(this);
        var opId;
        this.clearInactivityTimeout();
        return _a = {}, _a[$aOoPc.default] = function() {
            return this;
        }, _a.subscribe = function(observerOrNext, onError, onComplete) {
            var observer = getObserver(observerOrNext, onError, onComplete);
            opId = executeOperation(request, function(error, result) {
                if (error === null && result === null) {
                    if (observer.complete) observer.complete();
                } else if (error) {
                    if (observer.error) observer.error(error[0]);
                } else if (observer.next) observer.next(result);
            });
            return {
                unsubscribe: function() {
                    if (opId) {
                        unsubscribe(opId);
                        opId = null;
                    }
                }
            };
        }, _a;
    };
    SubscriptionClient.prototype.on = function(eventName, callback, context) {
        var handler = this.eventEmitter.on(eventName, callback, context);
        return function() {
            handler.off(eventName, callback, context);
        };
    };
    SubscriptionClient.prototype.onConnected = function(callback, context) {
        return this.on("connected", callback, context);
    };
    SubscriptionClient.prototype.onConnecting = function(callback, context) {
        return this.on("connecting", callback, context);
    };
    SubscriptionClient.prototype.onDisconnected = function(callback, context) {
        return this.on("disconnected", callback, context);
    };
    SubscriptionClient.prototype.onReconnected = function(callback, context) {
        return this.on("reconnected", callback, context);
    };
    SubscriptionClient.prototype.onReconnecting = function(callback, context) {
        return this.on("reconnecting", callback, context);
    };
    SubscriptionClient.prototype.onError = function(callback, context) {
        return this.on("error", callback, context);
    };
    SubscriptionClient.prototype.unsubscribeAll = function() {
        var _this = this;
        Object.keys(this.operations).forEach(function(subId) {
            _this.unsubscribe(subId);
        });
    };
    SubscriptionClient.prototype.applyMiddlewares = function(options) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var queue = function(funcs, scope) {
                var next = function(error) {
                    if (error) reject(error);
                    else if (funcs.length > 0) {
                        var f = funcs.shift();
                        if (f) f.applyMiddleware.apply(scope, [
                            options,
                            next
                        ]);
                    } else resolve(options);
                };
                next();
            };
            queue($af112994a64f4658$var$__spreadArray([], _this.middlewares, true), _this);
        });
    };
    SubscriptionClient.prototype.use = function(middlewares) {
        var _this = this;
        middlewares.map(function(middleware) {
            if (typeof middleware.applyMiddleware === "function") _this.middlewares.push(middleware);
            else throw new Error("Middleware must implement the applyMiddleware function.");
        });
        return this;
    };
    SubscriptionClient.prototype.getConnectionParams = function(connectionParams) {
        return function() {
            return new Promise(function(resolve, reject) {
                if (typeof connectionParams === "function") try {
                    return resolve(connectionParams.call(null));
                } catch (error) {
                    return reject(error);
                }
                resolve(connectionParams);
            });
        };
    };
    SubscriptionClient.prototype.executeOperation = function(options, handler) {
        var _this = this;
        if (this.client === null) this.connect();
        var opId = this.generateOperationId();
        this.operations[opId] = {
            options: options,
            handler: handler
        };
        this.applyMiddlewares(options).then(function(processedOptions) {
            _this.checkOperationOptions(processedOptions, handler);
            if (_this.operations[opId]) {
                _this.operations[opId] = {
                    options: processedOptions,
                    handler: handler
                };
                _this.sendMessage(opId, $04a39a3dc631764d$exports.default.GQL_START, processedOptions);
            }
        }).catch(function(error) {
            _this.unsubscribe(opId);
            handler(_this.formatErrors(error));
        });
        return opId;
    };
    SubscriptionClient.prototype.getObserver = function(observerOrNext, error, complete) {
        if (typeof observerOrNext === "function") return {
            next: function(v) {
                return observerOrNext(v);
            },
            error: function(e) {
                return error && error(e);
            },
            complete: function() {
                return complete && complete();
            }
        };
        return observerOrNext;
    };
    SubscriptionClient.prototype.createMaxConnectTimeGenerator = function() {
        var minValue = this.minWsTimeout;
        var maxValue = this.wsTimeout;
        return new $559c898bbe5275bb$exports({
            min: minValue,
            max: maxValue,
            factor: 1.2
        });
    };
    SubscriptionClient.prototype.clearCheckConnectionInterval = function() {
        if (this.checkConnectionIntervalId) {
            clearInterval(this.checkConnectionIntervalId);
            this.checkConnectionIntervalId = null;
        }
    };
    SubscriptionClient.prototype.clearMaxConnectTimeout = function() {
        if (this.maxConnectTimeoutId) {
            clearTimeout(this.maxConnectTimeoutId);
            this.maxConnectTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.clearTryReconnectTimeout = function() {
        if (this.tryReconnectTimeoutId) {
            clearTimeout(this.tryReconnectTimeoutId);
            this.tryReconnectTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.clearInactivityTimeout = function() {
        if (this.inactivityTimeoutId) {
            clearTimeout(this.inactivityTimeoutId);
            this.inactivityTimeoutId = null;
        }
    };
    SubscriptionClient.prototype.setInactivityTimeout = function() {
        var _this = this;
        if (this.inactivityTimeout > 0 && Object.keys(this.operations).length === 0) this.inactivityTimeoutId = setTimeout(function() {
            if (Object.keys(_this.operations).length === 0) _this.close();
        }, this.inactivityTimeout);
    };
    SubscriptionClient.prototype.checkOperationOptions = function(options, handler) {
        var query = options.query, variables = options.variables, operationName = options.operationName;
        if (!query) throw new Error("Must provide a query.");
        if (!handler) throw new Error("Must provide an handler.");
        if (!(0, $13eaac7b439f9222$exports.default)(query) && !(0, $9ac26eed8d9fa31d$exports.getOperationAST)(query, operationName) || operationName && !(0, $13eaac7b439f9222$exports.default)(operationName) || variables && !(0, $e2dc805d47b2fe5c$exports.default)(variables)) throw new Error("Incorrect option types. query must be a string or a document,`operationName` must be a string, and `variables` must be an object.");
    };
    SubscriptionClient.prototype.buildMessage = function(id, type, payload) {
        var payloadToReturn = payload && payload.query ? $af112994a64f4658$var$__assign($af112994a64f4658$var$__assign({}, payload), {
            query: typeof payload.query === "string" ? payload.query : (0, $ca64cd2ab238d4ac$exports.print)(payload.query)
        }) : payload;
        return {
            id: id,
            type: type,
            payload: payloadToReturn
        };
    };
    SubscriptionClient.prototype.formatErrors = function(errors) {
        if (Array.isArray(errors)) return errors;
        if (errors && errors.errors) return this.formatErrors(errors.errors);
        if (errors && errors.message) return [
            errors
        ];
        return [
            {
                name: "FormatedError",
                message: "Unknown error",
                originalError: errors
            }
        ];
    };
    SubscriptionClient.prototype.sendMessage = function(id, type, payload) {
        this.sendMessageRaw(this.buildMessage(id, type, payload));
    };
    SubscriptionClient.prototype.sendMessageRaw = function(message) {
        switch(this.status){
            case this.wsImpl.OPEN:
                var serializedMessage = JSON.stringify(message);
                try {
                    JSON.parse(serializedMessage);
                } catch (e) {
                    this.eventEmitter.emit("error", new Error("Message must be JSON-serializable. Got: " + message));
                }
                this.client.send(serializedMessage);
                break;
            case this.wsImpl.CONNECTING:
                this.unsentMessagesQueue.push(message);
                break;
            default:
                if (!this.reconnecting) this.eventEmitter.emit("error", new Error("A message was not sent because socket is not connected, is closing or is already closed. Message was: " + JSON.stringify(message)));
        }
    };
    SubscriptionClient.prototype.generateOperationId = function() {
        return String(++this.nextOperationId);
    };
    SubscriptionClient.prototype.tryReconnect = function() {
        var _this = this;
        if (!this.reconnect || this.backoff.attempts >= this.reconnectionAttempts) return;
        if (!this.reconnecting) {
            Object.keys(this.operations).forEach(function(key) {
                _this.unsentMessagesQueue.push(_this.buildMessage(key, $04a39a3dc631764d$exports.default.GQL_START, _this.operations[key].options));
            });
            this.reconnecting = true;
        }
        this.clearTryReconnectTimeout();
        var delay = this.backoff.duration();
        this.tryReconnectTimeoutId = setTimeout(function() {
            _this.connect();
        }, delay);
    };
    SubscriptionClient.prototype.flushUnsentMessagesQueue = function() {
        var _this = this;
        this.unsentMessagesQueue.forEach(function(message) {
            _this.sendMessageRaw(message);
        });
        this.unsentMessagesQueue = [];
    };
    SubscriptionClient.prototype.checkConnection = function() {
        if (this.wasKeepAliveReceived) {
            this.wasKeepAliveReceived = false;
            return;
        }
        if (!this.reconnecting) this.close(false, true);
    };
    SubscriptionClient.prototype.checkMaxConnectTimeout = function() {
        var _this = this;
        this.clearMaxConnectTimeout();
        this.maxConnectTimeoutId = setTimeout(function() {
            if (_this.status !== _this.wsImpl.OPEN) {
                _this.reconnecting = true;
                _this.close(false, true);
            }
        }, this.maxConnectTimeGenerator.duration());
    };
    SubscriptionClient.prototype.connect = function() {
        var _a;
        var _this = this;
        this.client = new ((_a = this.wsImpl).bind.apply(_a, $af112994a64f4658$var$__spreadArray([
            void 0,
            this.url,
            this.wsProtocols
        ], this.wsOptionArguments, false)))();
        this.checkMaxConnectTimeout();
        this.client.onopen = function() {
            return $af112994a64f4658$var$__awaiter(_this, void 0, void 0, function() {
                var connectionParams, error_1;
                return $af112994a64f4658$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(this.status === this.wsImpl.OPEN)) return [
                                3,
                                4
                            ];
                            this.clearMaxConnectTimeout();
                            this.closedByUser = false;
                            this.eventEmitter.emit(this.reconnecting ? "reconnecting" : "connecting");
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                this.connectionParams()
                            ];
                        case 2:
                            connectionParams = _a.sent();
                            this.sendMessage(undefined, $04a39a3dc631764d$exports.default.GQL_CONNECTION_INIT, connectionParams);
                            this.flushUnsentMessagesQueue();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error_1 = _a.sent();
                            this.sendMessage(undefined, $04a39a3dc631764d$exports.default.GQL_CONNECTION_ERROR, error_1);
                            this.flushUnsentMessagesQueue();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
        };
        this.client.onclose = function() {
            if (!_this.closedByUser) _this.close(false, false);
        };
        this.client.onerror = function(err) {
            _this.eventEmitter.emit("error", err);
        };
        this.client.onmessage = function(_a) {
            var data = _a.data;
            _this.processReceivedData(data);
        };
    };
    SubscriptionClient.prototype.processReceivedData = function(receivedData) {
        var parsedMessage;
        var opId;
        try {
            parsedMessage = JSON.parse(receivedData);
            opId = parsedMessage.id;
        } catch (e) {
            throw new Error("Message must be JSON-parseable. Got: " + receivedData);
        }
        if ([
            $04a39a3dc631764d$exports.default.GQL_DATA,
            $04a39a3dc631764d$exports.default.GQL_COMPLETE,
            $04a39a3dc631764d$exports.default.GQL_ERROR
        ].indexOf(parsedMessage.type) !== -1 && !this.operations[opId]) {
            this.unsubscribe(opId);
            return;
        }
        switch(parsedMessage.type){
            case $04a39a3dc631764d$exports.default.GQL_CONNECTION_ERROR:
                if (this.connectionCallback) this.connectionCallback(parsedMessage.payload);
                break;
            case $04a39a3dc631764d$exports.default.GQL_CONNECTION_ACK:
                this.eventEmitter.emit(this.reconnecting ? "reconnected" : "connected", parsedMessage.payload);
                this.reconnecting = false;
                this.backoff.reset();
                this.maxConnectTimeGenerator.reset();
                if (this.connectionCallback) this.connectionCallback();
                break;
            case $04a39a3dc631764d$exports.default.GQL_COMPLETE:
                var handler = this.operations[opId].handler;
                delete this.operations[opId];
                handler.call(this, null, null);
                break;
            case $04a39a3dc631764d$exports.default.GQL_ERROR:
                this.operations[opId].handler(this.formatErrors(parsedMessage.payload), null);
                delete this.operations[opId];
                break;
            case $04a39a3dc631764d$exports.default.GQL_DATA:
                var parsedPayload = !parsedMessage.payload.errors ? parsedMessage.payload : $af112994a64f4658$var$__assign($af112994a64f4658$var$__assign({}, parsedMessage.payload), {
                    errors: this.formatErrors(parsedMessage.payload.errors)
                });
                this.operations[opId].handler(null, parsedPayload);
                break;
            case $04a39a3dc631764d$exports.default.GQL_CONNECTION_KEEP_ALIVE:
                var firstKA = typeof this.wasKeepAliveReceived === "undefined";
                this.wasKeepAliveReceived = true;
                if (firstKA) this.checkConnection();
                if (this.checkConnectionIntervalId) {
                    clearInterval(this.checkConnectionIntervalId);
                    this.checkConnection();
                }
                this.checkConnectionIntervalId = setInterval(this.checkConnection.bind(this), this.wsTimeout);
                break;
            default:
                throw new Error("Invalid message type!");
        }
    };
    SubscriptionClient.prototype.unsubscribe = function(opId) {
        if (this.operations[opId]) {
            delete this.operations[opId];
            this.setInactivityTimeout();
            this.sendMessage(opId, $04a39a3dc631764d$exports.default.GQL_STOP, undefined);
        }
    };
    return SubscriptionClient;
}();
$af112994a64f4658$exports.SubscriptionClient = $af112994a64f4658$var$SubscriptionClient;


const $c370350a1c80bb49$var$EMBEDDABLE_SANDBOX_URL = (__testLocal__ = false)=>__testLocal__ ? "https://embed.apollo.local:3000/sandbox/explorer" : "https://sandbox.embed.apollographql.com/sandbox/explorer"; // Message types for Explorer state
const $c370350a1c80bb49$var$SCHEMA_ERROR = "SchemaError";
const $c370350a1c80bb49$var$SCHEMA_RESPONSE = "SchemaResponse"; // Message types for queries and mutations
const $c370350a1c80bb49$var$EXPLORER_QUERY_MUTATION_REQUEST = "ExplorerRequest";
const $c370350a1c80bb49$var$EXPLORER_QUERY_MUTATION_RESPONSE = "ExplorerResponse";
const $c370350a1c80bb49$var$EXPLORER_SUBSCRIPTION_REQUEST = "ExplorerSubscriptionRequest";
const $c370350a1c80bb49$var$EXPLORER_SUBSCRIPTION_RESPONSE = "ExplorerSubscriptionResponse";
const $c370350a1c80bb49$var$EXPLORER_SUBSCRIPTION_TERMINATION = "ExplorerSubscriptionTermination";
const $c370350a1c80bb49$var$EXPLORER_SET_SOCKET_ERROR = "ExplorerSetSocketError";
const $c370350a1c80bb49$var$EXPLORER_SET_SOCKET_STATUS = "ExplorerSetSocketStatus";
const $c370350a1c80bb49$var$IFRAME_DOM_ID = (uniqueId)=>`apollo-embed-${uniqueId}`; // Message types for authentication
const $c370350a1c80bb49$var$EXPLORER_LISTENING_FOR_HANDSHAKE = "ExplorerListeningForHandshake";
const $c370350a1c80bb49$var$HANDSHAKE_RESPONSE = "HandshakeResponse";
const $c370350a1c80bb49$var$SET_PARTIAL_AUTHENTICATION_TOKEN_FOR_PARENT = "SetPartialAuthenticationTokenForParent";
const $c370350a1c80bb49$var$TRIGGER_LOGOUT_IN_PARENT = "TriggerLogoutInParent";
const $c370350a1c80bb49$var$EXPLORER_LISTENING_FOR_PARTIAL_TOKEN = "ExplorerListeningForPartialToken";
const $c370350a1c80bb49$var$PARTIAL_AUTHENTICATION_TOKEN_RESPONSE = "PartialAuthenticationTokenResponse";
const $c370350a1c80bb49$var$INTROSPECTION_QUERY_WITH_HEADERS = "IntrospectionQueryWithHeaders";
const $c370350a1c80bb49$var$PARENT_LOGOUT_SUCCESS = "ParentLogoutSuccess";
const $c370350a1c80bb49$var$defaultHandleRequest = ({ legacyIncludeCookies: legacyIncludeCookies })=>{
    const handleRequestWithCookiePref = (endpointUrl, options)=>fetch(endpointUrl, Object.assign(Object.assign({}, options), legacyIncludeCookies ? {
            credentials: "include"
        } : // studio postMessage request. otherwise this would overwrite it.
        legacyIncludeCookies !== undefined ? {
            credentials: "omit"
        } : {}));
    return handleRequestWithCookiePref;
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $c370350a1c80bb49$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c370350a1c80bb49$var$readMultipartWebStream(response, mimeType) {
    if (response.body === null) throw new Error("Missing body");
    else if (typeof response.body.tee !== "function") // not sure if we actually need this check in explorer?
    throw new Error("Streaming bodies not supported by provided fetch implementation");
    const decoder = new TextDecoder("utf-8");
    let buffer = "";
    const messageBoundary = `--${mimeType.parameters.get("boundary") || "-"}`;
    const subscriptionTerminationMessageBoundary = "--graphql--";
    const reader = response.body.getReader();
    return {
        closeReadableStream: ()=>reader.cancel(),
        observable: new (0, $f5f90e31cecb0539$export$77cea355fa80b5f4)((observer)=>{
            function readMultipartStream() {
                reader.read().then((iteration)=>{
                    var _a, _b, _c;
                    if (iteration.done) {
                        (_a = observer.complete) === null || _a === void 0 || _a.call(observer);
                        return;
                    }
                    const chunk = decoder.decode(iteration.value);
                    buffer += chunk;
                    let boundaryIndex = buffer.indexOf(messageBoundary);
                    while(boundaryIndex > -1){
                        const message = buffer.slice(0, boundaryIndex);
                        buffer = buffer.slice(boundaryIndex + messageBoundary.length);
                        if (message.trim()) {
                            const messageStartIndex = message.indexOf("\r\n\r\n");
                            const chunkHeaders = Object.fromEntries(message.slice(0, messageStartIndex).split("\n").map((line)=>{
                                const i = line.indexOf(":");
                                if (i > -1) {
                                    const name = line.slice(0, i).trim();
                                    const value = line.slice(i + 1).trim();
                                    return [
                                        name,
                                        value
                                    ];
                                } else return null;
                            }).filter((h)=>!!h));
                            if (((_b = chunkHeaders["content-type"]) === null || _b === void 0 ? void 0 : _b.toLowerCase().indexOf("application/json")) === -1) throw new Error("Unsupported patch content type");
                            const bodyText = message.slice(messageStartIndex);
                            try {
                                (_c = observer.next) === null || _c === void 0 || _c.call(observer, Object.assign({
                                    data: JSON.parse(bodyText),
                                    headers: chunkHeaders,
                                    size: chunk.length
                                }, chunk.indexOf(subscriptionTerminationMessageBoundary) > -1 ? {
                                    shouldTerminate: true
                                } : {}));
                            } catch (err) {
                                // const parseError = err as ServerParseError;
                                // parseError.name = 'ServerParseError';
                                // parseError.response = response;
                                // parseError.statusCode = response.status;
                                // parseError.bodyText = bodyText;
                                throw err;
                            }
                        }
                        boundaryIndex = buffer.indexOf(messageBoundary);
                    }
                    readMultipartStream();
                }).catch((err)=>{
                    var _a, _b;
                    if (err.name === "AbortError") return; // if it is a network error, BUT there is graphql result info fire
                    // the next observer before calling error this gives apollo-client
                    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
                    // pass to UI this should only happen if we *also* have data as
                    // part of the response key per the spec
                    if (err.result && err.result.errors && err.result.data) // if we don't call next, the UI can only show networkError
                    // because AC didn't get any graphqlErrors this is graphql
                    // execution result info (i.e errors and possibly data) this is
                    // because there is no formal spec how errors should translate to
                    // http status codes. So an auth error (401) could have both data
                    // from a public field, errors from a private field, and a status
                    // of 401
                    // {
                    //  user { // this will have errors
                    //    firstName
                    //  }
                    //  products { // this is public so will have data
                    //    cost
                    //  }
                    // }
                    //
                    // the result of above *could* look like this:
                    // {
                    //   data: { products: [{ cost: "$10" }] },
                    //   errors: [{
                    //      message: 'your session has timed out',
                    //      path: []
                    //   }]
                    // }
                    // status code of above would be a 401
                    // in the UI you want to show data where you can, errors as data where you can
                    // and use correct http status codes
                    (_a = observer.next) === null || _a === void 0 || _a.call(observer, {
                        data: err.result,
                        size: Infinity
                    });
                    (_b = observer.error) === null || _b === void 0 || _b.call(observer, err);
                });
            }
            readMultipartStream();
        })
    };
}
const $c370350a1c80bb49$var$serializeFetchParameter = (p, label)=>{
    let serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        const parseError = new Error(`Network request failed. ${label} is not serializable`);
        throw parseError;
    }
    return serialized;
};
const $c370350a1c80bb49$var$constructMultipartForm = ({ fileVariables: inputtedFileVariables, requestBody: requestBody })=>$c370350a1c80bb49$var$__awaiter(void 0, void 0, void 0, function*() {
        const fileVariables = inputtedFileVariables.map((fileVariable)=>Object.assign(Object.assign({}, fileVariable), {
                files: fileVariable.files.map(({ arrayBuffer: arrayBuffer, fileName: fileName })=>new File([
                        new Blob([
                            arrayBuffer
                        ])
                    ], fileName))
            })); // the map element of a FormData maps indices to a single item array of variable names
        // as seen here https://github.com/jaydenseric/graphql-multipart-request-spec#file-list
        const map = {};
        let i = 0; // map must be the first thing in the form, followed by the files
        // other wise you get the error:
        // Misordered multipart fields; files should follow ‘map’ (https://github.com/jaydenseric/graphql-multipart-request-spec).
        const filesToAppend = []; // variables are added to the operation body with null values, the variable
        // name is used to match them to files uploaded in the later part of the request
        // according to the spec https://github.com/jaydenseric/graphql-multipart-request-spec
        let variablesWithNullsForFiles = requestBody.variables;
        fileVariables.forEach(({ files: files, variableKey: variableKey, isMultiFile: isMultiFile }, fileVariableIndex)=>{
            if (files === null || files === void 0 ? void 0 : files.length) {
                variablesWithNullsForFiles = Object.assign(Object.assign({}, variablesWithNullsForFiles), {
                    [variableKey]: isMultiFile ? new Array(files.length).fill(null) : null
                });
                Array.from(files).forEach((file)=>{
                    map[i] = [
                        `${fileVariables.length > 1 ? `${fileVariableIndex}.` : ""}variables.${variableKey}${isMultiFile ? `.${i}` : ""}`
                    ]; // in the request, there is expected to be a number appended that corresponds to each file
                    // https://github.com/jaydenseric/graphql-multipart-request-spec#file-list
                    filesToAppend.push([
                        i.toString(),
                        file,
                        file.name
                    ]);
                    i++;
                });
            }
        });
        const form = new FormData();
        form.append("operations", $c370350a1c80bb49$var$serializeFetchParameter({
            query: requestBody.query,
            operationName: requestBody.operationName,
            variables: variablesWithNullsForFiles
        }, "Payload"));
        form.append("map", JSON.stringify(map));
        filesToAppend.forEach((item)=>{
            form.append(item[0], item[1], item[2]);
        });
        return form;
    });
// to each request's headers if not present
function $c370350a1c80bb49$var$getHeadersWithContentType(headers) {
    const headersWithContentType = headers !== null && headers !== void 0 ? headers : {};
    if (Object.keys(headersWithContentType).every((key)=>key.toLowerCase() !== "content-type")) headersWithContentType["content-type"] = "application/json";
    return headersWithContentType;
}
function $c370350a1c80bb49$var$sendPostMessageToEmbed({ message: message, embeddedIFrameElement: embeddedIFrameElement, embedUrl: embedUrl }) {
    var _a;
    (_a = embeddedIFrameElement === null || embeddedIFrameElement === void 0 ? void 0 : embeddedIFrameElement.contentWindow) === null || _a === void 0 || _a.postMessage(message, embedUrl);
}
function $c370350a1c80bb49$var$executeOperation({ endpointUrl: endpointUrl, handleRequest: handleRequest, headers: headers, includeCookies: includeCookies, operationId: operationId, operation: operation, operationName: operationName, variables: variables, fileVariables: fileVariables, embeddedIFrameElement: embeddedIFrameElement, embedUrl: embedUrl, isMultipartSubscription: isMultipartSubscription, multipartSubscriptionClient: multipartSubscriptionClient }) {
    return $c370350a1c80bb49$var$__awaiter(this, void 0, void 0, function*() {
        const requestBody = {
            query: operation,
            variables: variables,
            operationName: operationName
        };
        let promise;
        if (fileVariables && fileVariables.length > 0) {
            const form = yield $c370350a1c80bb49$var$constructMultipartForm({
                fileVariables: fileVariables,
                requestBody: requestBody
            });
            promise = handleRequest(endpointUrl, Object.assign({
                method: "POST",
                headers: headers !== null && headers !== void 0 ? headers : {},
                body: form
            }, includeCookies ? {
                credentials: "include"
            } : {}));
        } else promise = handleRequest(endpointUrl, Object.assign({
            method: "POST",
            headers: $c370350a1c80bb49$var$getHeadersWithContentType(headers),
            body: JSON.stringify(requestBody)
        }, !!includeCookies ? {
            credentials: "include"
        } : {
            credentials: "omit"
        }));
        promise.then((response)=>$c370350a1c80bb49$var$__awaiter(this, void 0, void 0, function*() {
                var _a;
                const responseHeaders = {};
                response.headers.forEach((value, key)=>{
                    responseHeaders[key] = value;
                });
                const contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                const mimeType = contentType && new (0, (/*@__PURE__*/$parcel$interopDefault($9498ad806c1ca5b5$exports)))(contentType);
                if (mimeType && mimeType.type === "multipart" && mimeType.subtype === "mixed") {
                    multipartSubscriptionClient === null || multipartSubscriptionClient === void 0 || multipartSubscriptionClient.emit("connected");
                    const { observable: observable, closeReadableStream: closeReadableStream } = $c370350a1c80bb49$var$readMultipartWebStream(response, mimeType);
                    let isFirst = true;
                    const observableSubscription = observable.subscribe({
                        next (data) {
                            // if shouldTerminate is true, we got a server error
                            // we handle this in Explorer, but we need to disconnect from
                            // the readableStream & subscription here
                            if ("payload" in data.data) {
                                if ("shouldTerminate" in data && data.shouldTerminate) {
                                    observableSubscription.unsubscribe();
                                    closeReadableStream(); // the status being disconnected will be handled in the Explorer
                                    // but we send a pm just in case
                                    $c370350a1c80bb49$var$sendPostMessageToEmbed({
                                        message: {
                                            name: $c370350a1c80bb49$var$EXPLORER_SET_SOCKET_STATUS,
                                            status: "disconnected"
                                        },
                                        embeddedIFrameElement: embeddedIFrameElement,
                                        embedUrl: embedUrl
                                    });
                                }
                                $c370350a1c80bb49$var$sendPostMessageToEmbed({
                                    message: {
                                        name: $c370350a1c80bb49$var$EXPLORER_SUBSCRIPTION_RESPONSE,
                                        operationId: // Include the same operation ID in the response message's name
                                        // so the Explorer knows which operation it's associated with
                                        operationId,
                                        response: {
                                            data: data.data,
                                            status: response.status,
                                            headers: isFirst ? [
                                                responseHeaders,
                                                ...Array.isArray(data.headers) ? data.headers : data.headers ? [
                                                    data.headers
                                                ] : []
                                            ] : data.headers,
                                            size: data.size
                                        }
                                    },
                                    embeddedIFrameElement: embeddedIFrameElement,
                                    embedUrl: embedUrl
                                });
                            } else $c370350a1c80bb49$var$sendPostMessageToEmbed({
                                message: {
                                    name: $c370350a1c80bb49$var$EXPLORER_QUERY_MUTATION_RESPONSE,
                                    operationId: // Include the same operation ID in the response message's name
                                    // so the Explorer knows which operation it's associated with
                                    operationId,
                                    response: {
                                        incremental: data.data.incremental,
                                        data: data.data.data,
                                        errors: data.data.errors,
                                        extensions: data.data.extensions,
                                        path: data.data.path,
                                        status: response.status,
                                        headers: isFirst ? [
                                            responseHeaders,
                                            ...Array.isArray(data.headers) ? data.headers : data.headers ? [
                                                data.headers
                                            ] : []
                                        ] : data.headers,
                                        hasNext: true,
                                        size: data.size
                                    }
                                },
                                embeddedIFrameElement: embeddedIFrameElement,
                                embedUrl: embedUrl
                            });
                            isFirst = false;
                        },
                        error (err) {
                            const error = err && typeof err === "object" && "message" in err && typeof err.message === "string" ? Object.assign({
                                message: err.message
                            }, "stack" in err && typeof err.stack === "string" ? {
                                stack: err.stack
                            } : {}) : undefined;
                            $c370350a1c80bb49$var$sendPostMessageToEmbed({
                                message: {
                                    name: isMultipartSubscription ? $c370350a1c80bb49$var$EXPLORER_SUBSCRIPTION_RESPONSE : $c370350a1c80bb49$var$EXPLORER_QUERY_MUTATION_RESPONSE,
                                    operationId: // Include the same operation ID in the response message's name
                                    // so the Explorer knows which operation it's associated with
                                    operationId,
                                    response: Object.assign({
                                        data: null,
                                        error: error
                                    }, !isMultipartSubscription ? {
                                        hasNext: false
                                    } : {})
                                },
                                embeddedIFrameElement: embeddedIFrameElement,
                                embedUrl: embedUrl
                            });
                        },
                        complete () {
                            $c370350a1c80bb49$var$sendPostMessageToEmbed({
                                message: {
                                    name: isMultipartSubscription ? $c370350a1c80bb49$var$EXPLORER_SUBSCRIPTION_RESPONSE : $c370350a1c80bb49$var$EXPLORER_QUERY_MUTATION_RESPONSE,
                                    operationId: // Include the same operation ID in the response message's name
                                    // so the Explorer knows which operation it's associated with
                                    operationId,
                                    response: Object.assign({
                                        data: null,
                                        status: response.status,
                                        headers: isFirst ? responseHeaders : undefined
                                    }, !isMultipartSubscription ? {
                                        hasNext: false
                                    } : {})
                                },
                                embeddedIFrameElement: embeddedIFrameElement,
                                embedUrl: embedUrl
                            });
                        }
                    });
                    if (multipartSubscriptionClient) multipartSubscriptionClient.stopListeningCallback = ()=>{
                        closeReadableStream();
                        observableSubscription.unsubscribe();
                    };
                } else {
                    const json = yield response.json(); // if we didn't get the mime type multi part response,
                    // something went wrong with this multipart subscription
                    multipartSubscriptionClient === null || multipartSubscriptionClient === void 0 || multipartSubscriptionClient.emit("error");
                    multipartSubscriptionClient === null || multipartSubscriptionClient === void 0 || multipartSubscriptionClient.emit("disconnected");
                    $c370350a1c80bb49$var$sendPostMessageToEmbed({
                        message: {
                            name: isMultipartSubscription ? $c370350a1c80bb49$var$EXPLORER_SUBSCRIPTION_RESPONSE : $c370350a1c80bb49$var$EXPLORER_QUERY_MUTATION_RESPONSE,
                            operationId: // Include the same operation ID in the response message's name
                            // so the Explorer knows which operation it's associated with
                            operationId,
                            response: Object.assign(Object.assign({}, json), {
                                status: response.status,
                                headers: responseHeaders,
                                hasNext: false
                            })
                        },
                        embeddedIFrameElement: embeddedIFrameElement,
                        embedUrl: embedUrl
                    });
                }
            })).catch((err)=>{
            multipartSubscriptionClient === null || multipartSubscriptionClient === void 0 || multipartSubscriptionClient.emit("error", err);
            multipartSubscriptionClient === null || multipartSubscriptionClient === void 0 || multipartSubscriptionClient.emit("disconnected");
            const error = err && typeof err === "object" && "message" in err && typeof err.message === "string" ? Object.assign({
                message: err.message
            }, "stack" in err && typeof err.stack === "string" ? {
                stack: err.stack
            } : {}) : undefined;
            $c370350a1c80bb49$var$sendPostMessageToEmbed({
                message: {
                    name: isMultipartSubscription ? $c370350a1c80bb49$var$EXPLORER_SUBSCRIPTION_RESPONSE : $c370350a1c80bb49$var$EXPLORER_QUERY_MUTATION_RESPONSE,
                    operationId: // Include the same operation ID in the response message's name
                    // so the Explorer knows which operation it's associated with
                    operationId,
                    response: Object.assign({
                        data: null,
                        error: error
                    }, !isMultipartSubscription ? {
                        hasNext: false
                    } : {})
                },
                embeddedIFrameElement: embeddedIFrameElement,
                embedUrl: embedUrl
            });
        });
    });
}
function $c370350a1c80bb49$var$executeIntrospectionRequest({ endpointUrl: endpointUrl, headers: headers, includeCookies: includeCookies, introspectionRequestBody: introspectionRequestBody, embeddedIFrameElement: embeddedIFrameElement, embedUrl: embedUrl, handleRequest: handleRequest, operationId: operationId }) {
    return $c370350a1c80bb49$var$__awaiter(this, void 0, void 0, function*() {
        const { query: query, operationName: operationName } = JSON.parse(introspectionRequestBody);
        return handleRequest(endpointUrl, Object.assign({
            method: "POST",
            headers: $c370350a1c80bb49$var$getHeadersWithContentType(headers),
            body: JSON.stringify({
                query: query,
                operationName: operationName
            })
        }, !!includeCookies ? {
            credentials: "include"
        } : {
            credentials: "omit"
        })).then((response)=>response.json()).then((response)=>{
            if (response.errors && response.errors.length) $c370350a1c80bb49$var$sendPostMessageToEmbed({
                message: {
                    name: $c370350a1c80bb49$var$SCHEMA_ERROR,
                    errors: response.errors,
                    operationId: operationId
                },
                embeddedIFrameElement: embeddedIFrameElement,
                embedUrl: embedUrl
            });
            $c370350a1c80bb49$var$sendPostMessageToEmbed({
                message: {
                    name: $c370350a1c80bb49$var$SCHEMA_RESPONSE,
                    schema: response.data,
                    operationId: operationId
                },
                embeddedIFrameElement: embeddedIFrameElement,
                embedUrl: embedUrl
            });
        }).catch((error)=>{
            $c370350a1c80bb49$var$sendPostMessageToEmbed({
                message: {
                    name: $c370350a1c80bb49$var$SCHEMA_ERROR,
                    error: error,
                    operationId: operationId
                },
                embeddedIFrameElement: embeddedIFrameElement,
                embedUrl: embedUrl
            });
        });
    });
}
const $c370350a1c80bb49$var$handleAuthenticationPostMessage = ({ event: event, embeddedIFrameElement: embeddedIFrameElement, embedUrl: embedUrl })=>{
    const { data: data } = event; // When the embed authenticates, save the partial token in local storage
    if (data.name === $c370350a1c80bb49$var$SET_PARTIAL_AUTHENTICATION_TOKEN_FOR_PARENT) {
        const partialEmbedApiKeysString = window.localStorage.getItem("apolloStudioEmbeddedExplorerEncodedApiKey");
        const partialEmbedApiKeys = partialEmbedApiKeysString ? JSON.parse(partialEmbedApiKeysString) : {};
        partialEmbedApiKeys[data.localStorageKey] = data.partialToken;
        window.localStorage.setItem("apolloStudioEmbeddedExplorerEncodedApiKey", JSON.stringify(partialEmbedApiKeys));
    } // When the embed logs out, remove the partial token in local storage
    if (data.name === $c370350a1c80bb49$var$TRIGGER_LOGOUT_IN_PARENT) {
        const partialEmbedApiKeysString = window.localStorage.getItem("apolloStudioEmbeddedExplorerEncodedApiKey");
        const partialEmbedApiKeys = partialEmbedApiKeysString ? JSON.parse(partialEmbedApiKeysString) : {};
        delete partialEmbedApiKeys[data.localStorageKey];
        window.localStorage.setItem("apolloStudioEmbeddedExplorerEncodedApiKey", JSON.stringify(partialEmbedApiKeys));
        $c370350a1c80bb49$var$sendPostMessageToEmbed({
            message: {
                name: $c370350a1c80bb49$var$PARENT_LOGOUT_SUCCESS
            },
            embeddedIFrameElement: embeddedIFrameElement,
            embedUrl: embedUrl
        });
    }
    if (data.name === $c370350a1c80bb49$var$EXPLORER_LISTENING_FOR_PARTIAL_TOKEN && data.localStorageKey) {
        const partialEmbedApiKeysString = window.localStorage.getItem("apolloStudioEmbeddedExplorerEncodedApiKey");
        const partialEmbedApiKeys = partialEmbedApiKeysString ? JSON.parse(partialEmbedApiKeysString) : {};
        if (partialEmbedApiKeys && partialEmbedApiKeys[data.localStorageKey]) $c370350a1c80bb49$var$sendPostMessageToEmbed({
            message: {
                name: $c370350a1c80bb49$var$PARTIAL_AUTHENTICATION_TOKEN_RESPONSE,
                partialToken: partialEmbedApiKeys[data.localStorageKey]
            },
            embeddedIFrameElement: embeddedIFrameElement,
            embedUrl: embedUrl
        });
    }
};
function $c370350a1c80bb49$var$assertUnreachable(x) {
    throw new Error(`Didn't expect to get here ${x}`);
}
class $c370350a1c80bb49$var$SubscriptionClient {
    constructor(url, headers, protocol){
        this.unsubscribeFunctions = [];
        this.protocol = protocol;
        this.url = url;
        this.headers = headers;
    }
    get graphWsClient() {
        var _a, _b;
        const client = (_a = this._graphWsClient) !== null && _a !== void 0 ? _a : (0, $beb4c57f69a29bbe$exports.createClient)({
            url: this.url,
            lazy: true,
            connectionParams: (_b = this.headers) !== null && _b !== void 0 ? _b : {},
            keepAlive: 10000
        });
        this._graphWsClient = client;
        return client;
    }
    get transportSubscriptionClient() {
        var _a, _b;
        const client = (_a = this._transportSubscriptionClient) !== null && _a !== void 0 ? _a : new (0, $af112994a64f4658$exports.SubscriptionClient)(this.url, {
            reconnect: true,
            lazy: true,
            connectionParams: (_b = this.headers) !== null && _b !== void 0 ? _b : {}
        });
        this._transportSubscriptionClient = client;
        return client;
    }
    get multipartClient() {
        var _a;
        const client = (_a = this._multipartClient) !== null && _a !== void 0 ? _a : Object.assign(new (0, (/*@__PURE__*/$parcel$interopDefault($7cc026d227a3af34$exports)))(), {
            stopListeningCallback: undefined
        });
        this._multipartClient = client;
        return client;
    }
    onConnected(callback) {
        if (this.protocol === "http-multipart") {
            this.multipartClient.on("connected", callback);
            return ()=>this.multipartClient.off("connected", callback);
        }
        if (this.protocol === "graphql-ws") return this.graphWsClient.on("connected", callback);
        if (this.protocol === "subscriptions-transport-ws") return this.transportSubscriptionClient.onConnected(callback);
        $c370350a1c80bb49$var$assertUnreachable(this.protocol);
    }
    onConnecting(callback) {
        if (this.protocol === "http-multipart") return;
        if (this.protocol === "graphql-ws") return this.graphWsClient.on("connecting", callback);
        if (this.protocol === "subscriptions-transport-ws") return this.transportSubscriptionClient.onConnecting(callback);
        $c370350a1c80bb49$var$assertUnreachable(this.protocol);
    }
    onError(callback) {
        if (this.protocol === "http-multipart") {
            this.multipartClient.on("error", callback);
            return ()=>this.multipartClient.off("error", callback);
        }
        if (this.protocol === "graphql-ws") return this.graphWsClient.on("error", (error)=>callback(error));
        if (this.protocol === "subscriptions-transport-ws") return this.transportSubscriptionClient.onError((e)=>callback(e));
        $c370350a1c80bb49$var$assertUnreachable(this.protocol);
    }
    onReconnecting(callback) {
        if (this.protocol === "http-multipart") return;
        if (this.protocol === "graphql-ws") return;
        if (this.protocol === "subscriptions-transport-ws") return this.transportSubscriptionClient.onReconnecting(callback);
        $c370350a1c80bb49$var$assertUnreachable(this.protocol);
    }
    onReconnected(callback) {
        if (this.protocol === "http-multipart") return;
        if (this.protocol === "graphql-ws") return;
        if (this.protocol === "subscriptions-transport-ws") return this.transportSubscriptionClient.onReconnected(callback);
        $c370350a1c80bb49$var$assertUnreachable(this.protocol);
    }
    onDisconnected(callback) {
        if (this.protocol === "http-multipart") {
            this.multipartClient.on("disconnected", callback);
            return ()=>this.multipartClient.off("disconnected", callback);
        }
        if (this.protocol === "graphql-ws") return this.graphWsClient.on("closed", callback);
        if (this.protocol === "subscriptions-transport-ws") return this.transportSubscriptionClient.onDisconnected(callback);
        $c370350a1c80bb49$var$assertUnreachable(this.protocol);
    }
    dispose() {
        var _a, _b;
        if (this.protocol === "http-multipart") {
            (_b = (_a = this.multipartClient).stopListeningCallback) === null || _b === void 0 || _b.call(_a);
            return;
        }
        if (this.protocol === "graphql-ws") return this.graphWsClient.dispose();
        if (this.protocol === "subscriptions-transport-ws") return this.transportSubscriptionClient.close();
        $c370350a1c80bb49$var$assertUnreachable(this.protocol);
    }
    request(params) {
        return {
            subscribe: (subscribeParams)=>$c370350a1c80bb49$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d;
                    if (this.protocol === "http-multipart" && params.httpMultipartParams) // we only use subscribeParams for websockets, for http multipart subs
                    // we do all responding in executeOperation, since this is where we set
                    // up the Observable
                    yield $c370350a1c80bb49$var$executeOperation({
                        operation: params.query,
                        operationName: params.operationName,
                        variables: params.variables,
                        headers: (_a = this.headers) !== null && _a !== void 0 ? _a : {},
                        includeCookies: (_c = (_b = params.httpMultipartParams) === null || _b === void 0 ? void 0 : _b.includeCookies) !== null && _c !== void 0 ? _c : false,
                        endpointUrl: this.url,
                        embeddedIFrameElement: params.embeddedIFrameElement,
                        embedUrl: params.embedUrl,
                        operationId: params.operationId,
                        handleRequest: (_d = params.httpMultipartParams) === null || _d === void 0 ? void 0 : _d.handleRequest,
                        isMultipartSubscription: true,
                        multipartSubscriptionClient: this.multipartClient
                    });
                    if (this.protocol === "graphql-ws") this.unsubscribeFunctions.push(this.graphWsClient.subscribe(params, Object.assign(Object.assign({}, subscribeParams), {
                        next: (data)=>{
                            var _a;
                            return (_a = subscribeParams.next) === null || _a === void 0 ? void 0 : _a.call(subscribeParams, data);
                        },
                        error: (error)=>{
                            var _a;
                            return (_a = subscribeParams.error) === null || _a === void 0 ? void 0 : _a.call(subscribeParams, error);
                        },
                        complete: ()=>{}
                    })));
                    if (this.protocol === "subscriptions-transport-ws") return this.transportSubscriptionClient.request(params).subscribe(subscribeParams);
                    else return undefined;
                })
        };
    }
    unsubscribeAll() {
        var _a, _b;
        if (this.protocol === "http-multipart") (_b = (_a = this.multipartClient).stopListeningCallback) === null || _b === void 0 || _b.call(_a);
        if (this.protocol === "graphql-ws") {
            this.unsubscribeFunctions.forEach((off)=>{
                off();
            });
            this.unsubscribeFunctions = [];
        }
        if (this.protocol === "subscriptions-transport-ws") return this.transportSubscriptionClient.unsubscribeAll();
    }
}
function $c370350a1c80bb49$var$setParentSocketError({ error: error, embeddedIFrameElement: embeddedIFrameElement, embedUrl: embedUrl }) {
    $c370350a1c80bb49$var$sendPostMessageToEmbed({
        message: {
            name: $c370350a1c80bb49$var$EXPLORER_SET_SOCKET_ERROR,
            error: error
        },
        embeddedIFrameElement: embeddedIFrameElement,
        embedUrl: embedUrl
    });
}
function $c370350a1c80bb49$var$setParentSocketStatus({ status: status, embeddedIFrameElement: embeddedIFrameElement, embedUrl: embedUrl }) {
    $c370350a1c80bb49$var$sendPostMessageToEmbed({
        message: {
            name: $c370350a1c80bb49$var$EXPLORER_SET_SOCKET_STATUS,
            status: status
        },
        embeddedIFrameElement: embeddedIFrameElement,
        embedUrl: embedUrl
    });
}
function $c370350a1c80bb49$var$executeSubscription({ operation: operation, operationName: operationName, variables: variables, headers: headers, embeddedIFrameElement: embeddedIFrameElement, operationId: operationId, embedUrl: embedUrl, subscriptionUrl: subscriptionUrl, protocol: protocol, httpMultipartParams: httpMultipartParams }) {
    const client = new $c370350a1c80bb49$var$SubscriptionClient(subscriptionUrl, headers !== null && headers !== void 0 ? headers : {}, protocol);
    const checkForSubscriptionTermination = (event)=>{
        if (event.data.name === $c370350a1c80bb49$var$EXPLORER_SUBSCRIPTION_TERMINATION) {
            client.unsubscribeAll();
            window.removeEventListener("message", checkForSubscriptionTermination);
        }
    };
    window.addEventListener("message", checkForSubscriptionTermination);
    client.onError((e)=>$c370350a1c80bb49$var$setParentSocketError({
            error: JSON.parse(JSON.stringify(e)),
            embeddedIFrameElement: embeddedIFrameElement,
            embedUrl: embedUrl
        }));
    client.onConnected(()=>{
        $c370350a1c80bb49$var$setParentSocketError({
            error: undefined,
            embeddedIFrameElement: embeddedIFrameElement,
            embedUrl: embedUrl
        });
        $c370350a1c80bb49$var$setParentSocketStatus({
            status: "connected",
            embeddedIFrameElement: embeddedIFrameElement,
            embedUrl: embedUrl
        });
    });
    client.onReconnected(()=>{
        $c370350a1c80bb49$var$setParentSocketError({
            error: undefined,
            embeddedIFrameElement: embeddedIFrameElement,
            embedUrl: embedUrl
        });
        $c370350a1c80bb49$var$setParentSocketStatus({
            status: "connected",
            embeddedIFrameElement: embeddedIFrameElement,
            embedUrl: embedUrl
        });
    });
    client.onConnecting(()=>$c370350a1c80bb49$var$setParentSocketStatus({
            status: "connecting",
            embeddedIFrameElement: embeddedIFrameElement,
            embedUrl: embedUrl
        }));
    client.onReconnecting(()=>$c370350a1c80bb49$var$setParentSocketStatus({
            status: "connecting",
            embeddedIFrameElement: embeddedIFrameElement,
            embedUrl: embedUrl
        }));
    client.onDisconnected(()=>$c370350a1c80bb49$var$setParentSocketStatus({
            status: "disconnected",
            embeddedIFrameElement: embeddedIFrameElement,
            embedUrl: embedUrl
        }));
    client.request({
        query: operation,
        variables: variables !== null && variables !== void 0 ? variables : {},
        operationName: operationName,
        embeddedIFrameElement: embeddedIFrameElement,
        embedUrl: embedUrl,
        httpMultipartParams: httpMultipartParams,
        operationId: operationId
    }).subscribe(// we do all responding in executeOperation, since this is where we set
    // up the Observable
    {
        next (data) {
            $c370350a1c80bb49$var$sendPostMessageToEmbed({
                message: {
                    name: $c370350a1c80bb49$var$EXPLORER_SUBSCRIPTION_RESPONSE,
                    operationId: // Include the same operation ID in the response message's name
                    // so the Explorer knows which operation it's associated with
                    operationId,
                    // we use different versions of graphql in Explorer & here,
                    // Explorer expects an Object, which is what this is in reality
                    response: {
                        data: data
                    }
                },
                embeddedIFrameElement: embeddedIFrameElement,
                embedUrl: embedUrl
            });
        },
        error: (error)=>{
            $c370350a1c80bb49$var$sendPostMessageToEmbed({
                message: {
                    name: $c370350a1c80bb49$var$EXPLORER_SUBSCRIPTION_RESPONSE,
                    operationId: // Include the same operation ID in the response message's name
                    // so the Explorer knows which operation it's associated with
                    operationId,
                    response: {
                        error: JSON.parse(JSON.stringify(error))
                    }
                },
                embeddedIFrameElement: embeddedIFrameElement,
                embedUrl: embedUrl
            });
        }
    });
    return {
        dispose: ()=>window.removeEventListener("message", checkForSubscriptionTermination)
    };
}
function $c370350a1c80bb49$var$setupSandboxEmbedRelay({ handleRequest: handleRequest, embeddedSandboxIFrameElement: embeddedSandboxIFrameElement, __testLocal__: __testLocal__ }) {
    const embedUrl = $c370350a1c80bb49$var$EMBEDDABLE_SANDBOX_URL(__testLocal__); // Callback definition
    const onPostMessageReceived = (event)=>{
        $c370350a1c80bb49$var$handleAuthenticationPostMessage({
            event: event,
            embedUrl: embedUrl,
            embeddedIFrameElement: embeddedSandboxIFrameElement
        }); // Any pm can be listened for here, not just the ones we know the
        // structure of. Some have a data field that is not an object
        const data = typeof event.data === "object" ? event.data : undefined;
        if (data && "name" in data) {
            // When embed connects, send a handshake message
            if (data.name === $c370350a1c80bb49$var$EXPLORER_LISTENING_FOR_HANDSHAKE) $c370350a1c80bb49$var$sendPostMessageToEmbed({
                message: {
                    name: $c370350a1c80bb49$var$HANDSHAKE_RESPONSE,
                    parentHref: window.location.href
                },
                embeddedIFrameElement: embeddedSandboxIFrameElement,
                embedUrl: embedUrl
            });
            if (data.name === $c370350a1c80bb49$var$INTROSPECTION_QUERY_WITH_HEADERS) {
                const { introspectionRequestBody: introspectionRequestBody, introspectionRequestHeaders: introspectionRequestHeaders, includeCookies: includeCookies, sandboxEndpointUrl: sandboxEndpointUrl, operationId: operationId } = data;
                if (sandboxEndpointUrl) $c370350a1c80bb49$var$executeIntrospectionRequest({
                    endpointUrl: sandboxEndpointUrl,
                    introspectionRequestBody: introspectionRequestBody,
                    headers: introspectionRequestHeaders,
                    includeCookies: includeCookies,
                    embeddedIFrameElement: embeddedSandboxIFrameElement,
                    embedUrl: embedUrl,
                    handleRequest: handleRequest,
                    operationId: operationId
                });
            } // Check to see if the posted message indicates that the user is
            // executing a query or mutation or subscription in the Explorer
            const isQueryOrMutation = data.name === $c370350a1c80bb49$var$EXPLORER_QUERY_MUTATION_REQUEST;
            const isSubscription = data.name === $c370350a1c80bb49$var$EXPLORER_SUBSCRIPTION_REQUEST; // If the user is executing a query or mutation or subscription...
            if ((isQueryOrMutation || isSubscription) && data.operation && data.operationId) {
                // Extract the operation details from the event.data object
                const { operation: operation, variables: variables, operationName: operationName, operationId: operationId, headers: headers } = data;
                if (isQueryOrMutation) {
                    const { endpointUrl: endpointUrl, includeCookies: includeCookies } = data;
                    if (!endpointUrl) throw new Error("Something went wrong, we should not have gotten here. The sandbox endpoint url was not sent.");
                    $c370350a1c80bb49$var$executeOperation({
                        endpointUrl: endpointUrl,
                        handleRequest: handleRequest,
                        headers: headers,
                        includeCookies: includeCookies,
                        embeddedIFrameElement: embeddedSandboxIFrameElement,
                        operationId: operationId,
                        operation: operation,
                        variables: variables,
                        fileVariables: "fileVariables" in data ? data.fileVariables : undefined,
                        operationName: operationName,
                        embedUrl: embedUrl,
                        isMultipartSubscription: false
                    });
                } else if (isSubscription) {
                    const { httpMultipartParams: httpMultipartParams } = data;
                    $c370350a1c80bb49$var$executeSubscription({
                        operation: operation,
                        operationName: operationName,
                        variables: variables,
                        headers: headers,
                        embeddedIFrameElement: embeddedSandboxIFrameElement,
                        operationId: operationId,
                        embedUrl: embedUrl,
                        subscriptionUrl: data.subscriptionUrl,
                        protocol: data.protocol,
                        httpMultipartParams: Object.assign(Object.assign({}, httpMultipartParams), {
                            handleRequest: handleRequest
                        })
                    });
                }
            }
        }
    }; // Execute our callback whenever window.postMessage is called
    window.addEventListener("message", onPostMessageReceived);
    return {
        dispose: ()=>window.removeEventListener("message", onPostMessageReceived)
    };
}
var $c370350a1c80bb49$var$name = "@apollo/sandbox";
var $c370350a1c80bb49$var$version = "2.5.0";
var $c370350a1c80bb49$var$author = "packages@apollographql.com";
var $c370350a1c80bb49$var$license = "MIT";
var $c370350a1c80bb49$var$repository = {
    type: "git",
    url: "https://github.com/apollographql/embeddable-explorer/sandbox"
};
var $c370350a1c80bb49$var$homepage = "https://github.com/apollographql/embeddable-explorer/sandbox#readme";
var $c370350a1c80bb49$var$main = "dist/index.cjs";
var $c370350a1c80bb49$var$module = "dist/index.mjs";
var $c370350a1c80bb49$var$typings = "dist/src/index.d.ts";
var $c370350a1c80bb49$var$engines = {
    node: ">=12.0",
    npm: ">=7.0"
};
var $c370350a1c80bb49$var$volta = {
    node: "16.13.0",
    npm: "8.3.1"
};
var $c370350a1c80bb49$var$scripts = {
    build: "npm run build:cjs-esm",
    "build:cjs-esm": "rm -rf dist && rollup -c buildHelpers/rollup.cjs-esm.config.js && cp src/index.cjs dist/index.cjs && cp src/react/index.cjs dist/react/index.cjs && node ./buildHelpers/prepareDist.js sandbox",
    "build:umd": "rm -rf dist && rollup -c buildHelpers/rollup.umd.config.js",
    lint: "eslint --ext .js,.jsx,.ts,.tsx .",
    size: "size-limit",
    analyze: "size-limit --why",
    "typescript:check": "tsc --noEmit",
    "prettier:check": "prettier --check .",
    "prettier:fix": "prettier --write ."
};
var $c370350a1c80bb49$var$husky = {
    hooks: {
        "pre-commit": "npm run lint"
    }
};
var $c370350a1c80bb49$var$prettier = {
    printWidth: 80,
    semi: true,
    singleQuote: true,
    trailingComma: "es5",
    endOfLine: "auto"
};
var $c370350a1c80bb49$var$peerDependencies = {
    react: "^16.8.0 || ^17.0.0 || ^18.0.0",
    "react-dom": "^16.8.0 || ^17.0.0 || ^18.0.0"
};
var $c370350a1c80bb49$var$peerDependenciesMeta = {
    react: {
        optional: true
    },
    "react-dom": {
        optional: true
    }
};
var $c370350a1c80bb49$var$dependencies = {
    "@types/whatwg-mimetype": "^3.0.0",
    eventemitter3: "3.1.0",
    "graphql-ws": "^5.9.0",
    "subscriptions-transport-ws": "^0.11.0",
    "whatwg-mimetype": "^3.0.0",
    "zen-observable-ts": "^1.1.0"
};
var $c370350a1c80bb49$var$packageJSON = {
    name: $c370350a1c80bb49$var$name,
    version: $c370350a1c80bb49$var$version,
    author: $c370350a1c80bb49$var$author,
    license: $c370350a1c80bb49$var$license,
    repository: $c370350a1c80bb49$var$repository,
    homepage: $c370350a1c80bb49$var$homepage,
    main: $c370350a1c80bb49$var$main,
    module: $c370350a1c80bb49$var$module,
    typings: $c370350a1c80bb49$var$typings,
    engines: $c370350a1c80bb49$var$engines,
    volta: $c370350a1c80bb49$var$volta,
    scripts: $c370350a1c80bb49$var$scripts,
    husky: $c370350a1c80bb49$var$husky,
    prettier: $c370350a1c80bb49$var$prettier,
    "size-limit": [
        {
            path: "dist/index.production.min.js",
            limit: "10 KB"
        },
        {
            path: "dist/index.mjs",
            limit: "10 KB"
        }
    ],
    peerDependencies: $c370350a1c80bb49$var$peerDependencies,
    peerDependenciesMeta: $c370350a1c80bb49$var$peerDependenciesMeta,
    dependencies: $c370350a1c80bb49$var$dependencies
};
let $c370350a1c80bb49$var$idCounter = 0;
class $c370350a1c80bb49$export$a9c23c6ac3fc3eca {
    constructor(options){
        var _a;
        this.options = options;
        this.__testLocal__ = !!this.options.__testLocal__;
        this.validateOptions();
        this.handleRequest = (_a = this.options.handleRequest) !== null && _a !== void 0 ? _a : $c370350a1c80bb49$var$defaultHandleRequest({
            legacyIncludeCookies: this.options.includeCookies
        });
        this.uniqueEmbedInstanceId = $c370350a1c80bb49$var$idCounter++;
        this.embeddedSandboxIFrameElement = this.injectEmbed();
        this.disposable = $c370350a1c80bb49$var$setupSandboxEmbedRelay({
            embeddedSandboxIFrameElement: this.embeddedSandboxIFrameElement,
            handleRequest: this.handleRequest,
            __testLocal__: !!this.__testLocal__
        });
    }
    dispose() {
        var _a; // remove the dom element
        (_a = document.getElementById($c370350a1c80bb49$var$IFRAME_DOM_ID(this.uniqueEmbedInstanceId))) === null || _a === void 0 || _a.remove(); // remove the listener
        this.disposable.dispose();
    }
    injectEmbed() {
        var _a, _b, _c, _d, _e;
        let element;
        const { target: target, runTelemetry: runTelemetry } = this.options;
        const { includeCookies: includeCookies, sharedHeaders: sharedHeaders } = this.options.initialState || {};
        const queryParams = Object.assign(Object.assign(Object.assign({
            runtime: this.options.runtime,
            endpoint: this.options.initialEndpoint,
            subscriptionEndpoint: this.options.initialSubscriptionEndpoint
        }, this.options.initialState && "collectionId" in this.options.initialState ? {
            defaultCollectionEntryId: this.options.initialState.operationId,
            defaultCollectionId: this.options.initialState.collectionId
        } : {}), this.options.initialState && "document" in this.options.initialState ? {
            defaultDocument: this.options.initialState.document ? encodeURIComponent(this.options.initialState.document) : undefined,
            defaultVariables: this.options.initialState.variables ? encodeURIComponent(JSON.stringify(this.options.initialState.variables, null, 2)) : undefined,
            defaultHeaders: this.options.initialState.headers ? encodeURIComponent(JSON.stringify(this.options.initialState.headers)) : undefined
        } : {}), {
            sharedHeaders: sharedHeaders ? encodeURIComponent(JSON.stringify(sharedHeaders)) : undefined,
            defaultIncludeCookies: includeCookies,
            hideCookieToggle: (_a = this.options.hideCookieToggle) !== null && _a !== void 0 ? _a : true,
            parentSupportsSubscriptions: true,
            version: $c370350a1c80bb49$var$packageJSON.version,
            runTelemetry: runTelemetry === undefined ? true : runTelemetry,
            initialRequestQueryPlan: (_b = this.options.initialRequestQueryPlan) !== null && _b !== void 0 ? _b : false,
            shouldDefaultAutoupdateSchema: (_d = (_c = this.options.initialState) === null || _c === void 0 ? void 0 : _c.pollForSchemaUpdates) !== null && _d !== void 0 ? _d : true,
            endpointIsEditable: this.options.endpointIsEditable
        });
        const queryString = Object.entries(queryParams).filter(([_, value])=>value !== undefined).map(([key, value])=>`${key}=${value}`).join("&");
        if (typeof target === "string") element = (_e = document === null || document === void 0 ? void 0 : document.querySelector) === null || _e === void 0 ? void 0 : _e.call(document, target);
        else element = target;
        const iframeElement = document.createElement("iframe");
        iframeElement.src = `${$c370350a1c80bb49$var$EMBEDDABLE_SANDBOX_URL(this.__testLocal__)}?${queryString}`;
        iframeElement.id = $c370350a1c80bb49$var$IFRAME_DOM_ID(this.uniqueEmbedInstanceId); // default to `true` (`true` and `undefined` both ok)
        if (this.options.allowDynamicStyles !== false) iframeElement.setAttribute("style", "height: 100%; width: 100%; border: none;");
        element === null || element === void 0 || element.appendChild(iframeElement); // inject the Apollo favicon if there is not one on this page
        fetch(`${window.location.origin}/favicon.ico`).then((response)=>{
            if (response.status === 404) {
                var existingLink = document.querySelector('link[rel*="icon"]');
                if (!existingLink) {
                    var darkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
                    [
                        "icon",
                        "apple-touch-icon"
                    ].forEach((id)=>{
                        var link = document.createElement("link");
                        link.rel = id;
                        link.href = `https://embeddable-explorer.cdn.apollographql.com/_latest/public/assets/favicon${darkMode ? "-dark" : ""}.png`;
                        document.head.appendChild(link);
                    });
                }
            }
        }).catch(()=>{});
        return iframeElement;
    }
    validateOptions() {
        var _a;
        if (!this.options.target) throw new Error('"target" is required');
        if (this.options.includeCookies !== undefined) console.warn("Passing `includeCookies` is deprecated. If you would like to set a default includeCookies value, please use `initialState.includeCookies` instead.");
        if (this.options.includeCookies !== undefined && (this.options.hideCookieToggle !== undefined || ((_a = this.options.initialState) === null || _a === void 0 ? void 0 : _a.includeCookies) !== undefined)) throw new Error("Passing `includeCookies` is deprecated and will override your sandbox connection settings configuration.");
    }
}









new (0, $c370350a1c80bb49$export$a9c23c6ac3fc3eca)({
    target: "#embedded-apollo-sandbox",
    initialEndpoint: `${window.location.origin}/api/graphql`,
    initialState: {
        pollForSchemaUpdates: false
    }
});


//# sourceMappingURL=index.8eed85ea.js.map
